import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import GoogleMapReact from "google-map-react";
import AlertModal from "commonComponents/Popup/alertModal";
import {
    MapContainer,
    FilterHeader,
    SiteSettingModalContainer,
} from "pages/Map/MapStyled";
import { useNavigate } from "react-router-dom";
import { CircleBtn } from "assets/css/globle";
import { useHookstate } from "@hookstate/core";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Snackbar from "@mui/material/Snackbar";
import { HoverWindow } from "commonComponents/HoleUI/CarsOnCourseStyled";
import {
    MESSAGE_FLEET_GLOBAL_STATES,
    MAP_GLOBAL_STATES,
    COMMON_COMPONENTS_STATES,
    SITELOCATION_GLOBAL_STATE,
    SITEID_GLOBAL_STATE,
    SLIDER_STATE,
    SiteSetupAction,
    UPDATED_CAR_DATA_STATE,
    FLEET_GLOBAL_STATES,
    COP_GLOBAL_STATES
} from "globalStore/globalStore";
import {
    MapHoleMarker,
    MapPointMarker,
    MapTeesMarker,
    MapCarIcon,
    MapCenterMarker,
    LocationIcon,
    NewMapPointMarker,
    NewMapTeesMarker,
    TaggedCarIconComponent,
} from "./MapIcons";
import { uuid } from "_helperFunctions/uuid";
import CarList from "./CarList";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { kmlLayerData as kmlLayerDataAction } from "redux/reduxToolkitServices/_commonReducers/commonReducers";

import { headersConfigData } from "../../redux/reduxToolkitServices/_commonServices/commonServices";
import axios from "axios";
import CarNotAvailableModal from "./CarNotAvailableModal";
import { isValidLocation } from "_helperFunctions/isValidLocation";
import { HistoryIconPopup } from "./HistoryIconPopup";
import SignalIcon from "assets/svgIcons/SignalIcon";
import {
    actionZoneBufferWidth,
    isUserAdmin,
    reasonForReportString,
    featureKey,
    NORMAL_POLYGON_Z_INDEX,
    mapSymbols,
    newPolyFillColor,
    actionZoneTypes,
    sizzleReelAZText,
    SELECTED_POLYGON_Z_INDEX,
    maximumMapZoomLevel,
    azEditingCursorCssClass,
    azCreateCursorCssClass,
    getFeatureSetOption,
    getFeaturesList,
    isUserSupport,
    siteSettingsTypes,
    settingsPoITypes,
    carType
} from "constant";
import { filterCars } from "./carFilter";
import SiteAreaPopup from "./popups/SiteAreaPopup";
import SiteSetupAreasPopups from "./popups/SiteSetupAreasPopups";
import COGAndTeeAndPOIEditPopup from "./popups/COGAndTeeAndPOIEditPopup";
import COGAndTeeAndPOIAddPopup from "./popups/COGAndTeeAndPOIAddPopup";
import MapMobileMenu from "./MapMobileMenu";
import MapTopMenu from "./MapTopMenu";
import MapSideMenu from "./MapSideMenu";
import MapLegend from "./MapLegend";
import PaperComponent from "./PaperComponent";
import { deepClone } from "./functions/deepClone";
import { checkZoom } from "./functions/checkZoom";
import { checkCenterLat } from "./functions/checkCenterLat";
import { displayPolygon } from "./functions/displayPolygon";
import { checkCenterLng } from "./functions/checkCenterLng";
import { displayCars } from "./functions/displayCars";
import { createBufGeofenceVertices } from "./functions/geofence/createBufGeofenceVertices";
import { getCourseExtents } from "./functions/getCourseExtents";
import SendMsgToCars from "./popups/SendMsgToCars";
import CarDetailsOnCarIcon from "./popups/CarDetailsOnCarIcon";
import { handleOpen2 } from "./functions/events/handleOpen2";
import { handleEditChange } from "./functions/events/handleEditChange";
import { getPaceString } from "./functions/getPaceString";
import { hidePolygon } from "./functions/hidePolygon";
import { resetPrevPolygon } from "./functions/resetPrevPolygon";
import { getActionZoneColor } from "./functions/getActionZoneColor";
import { getMapBoundsForFindCars } from "./functions/getMapBoundsForFindCars";
import { getMapBoundsForAllCars } from "./functions/getMapBoundsForAllCars";
import { showSpecifiCarTrackLocation } from "./functions/showSpecifiCarTrackLocation";
import { displayHideAreaPolygon } from "./functions/displayHideAreaPolygon";
import { showSpecifiCarHistory } from "./functions/showSpecifiCarHistory";
import { drawMarker } from "./functions/events/drawMarker";
import { openEditModal } from "./functions/events/openEditModal";
import HoleAreaAlreadyExistsPopup from "./popups/HoleAreaAlreadyExistsPopup";
import { getMapBoundsForSite } from "./functions/getMapBoundsForSite";
import LoadingBackdrop from "./popups/LoadingBackdrop";
import ErrorPopup from "./popups/ErrorPopup";
import { Modal } from "@mui/material";
import { PopUpContainer } from "assets/css/globle";
import { Box } from "@mui/system";
import { distanceCalc } from '../Pins/utils/visageHelpers';
import MapBottom from "./MapBottom";

export const MapReactComponent = () => {
    const { t } = useTranslation();

    // Redux API data rendering
    const {
        siteLocationsData,
        getCarPathActionZone,
        siteSetupData,
        holeMarkerData,
        mapInformationData,
        siteSettingsData,
        specificCarHistoryData,
        getCarTrackData,
        getUserRole,
        clickToDriveApiStatus,
        kmlLayerData,
        mapImageData,
        mapXYPointsData,
        getVisagaUsersListAction,
        getHoleAreasState,
        getSiteAreasState
    } = useSelector((state) => state.commonReducers) || [];

    const { AreaFilterData } = useSelector((state) => state.firstReducer);

    // hookstate global variable import
    const { isLoading, tagCarFromFleet } = useHookstate(MESSAGE_FLEET_GLOBAL_STATES);

    const { weatherAlertGlobalState } = useHookstate(FLEET_GLOBAL_STATES);

    const {
        showAreas,
        showCenterOfGreens,
        showTeeMarkers,
        showPointsOfInterest,
        teesBtn,
        gmsBtn,
        fwysBtn,
        showAll,
        hideAll,
        stgsBtn,
        imageUrl,
        imageHoleNo,
        addSiteSetup,
        courseNo,
        typeHole,
        holeNum,
        editSiteSetup,
        addSelectType,
        extsBtn,
        holeView,
        showSiteData,
        poiSiteData,
        teeSiteData,
        areaModified,
        refreshSiteSetupAreas,
        holeChange,
        isSaveSiteArea,
        isSaveHoleArea
    } = useHookstate(SiteSetupAction);

    const { siteLocationGlobalData, singleSiteLocationData } = useHookstate(SITELOCATION_GLOBAL_STATE);

    const { siteId, selectSite } = useHookstate(SITEID_GLOBAL_STATE);

    const { sliderState } = useHookstate(SLIDER_STATE);

    const {
        getCheckedCars,
        mapSideNavTabState,
        cartPathActionZone,
        geofenceActionZone,
        messageActionZone,
        controlsActionZone,
        taggedCarsSaverGlobalState,
        messageFindCar,
        paceFindCar,
        specificCarTrackHistory,
        addActionZonePolygon,
        openActionZoneWindow,
        editActionZonePolygonData,
        editActionZonePolygonVertices,
        carHistoryList,
        historyOptions,
        selectedHistoryOption,
        enableClickToDriveFeature,
        showTaggedCarArrayClickToDrive,
        showTaggedCarArrayClickToDriveInputValueSetter,
        isEnabledActionZone,
        deactiveAllAction,
        toggleDeactiveAllAction,
        previousEditedPolygon,
        mapCarsSelectAll,
        marshalCarsGlobalState,
        specialCarsGlobalState,
        memberCarsGlobalState,
        bewrageCarsGlobalState,
        fleetCarsGlobalState,
        notInUseCarsGlobalState,
        carsNotCommunicatingGlobalState,
        outsidePerimeterGlobalState,
        mapsDataGlobalState,
        carNumberHover,
        mapDataGlobalState,
        showTaggedCar,
        overlay,
        heightMapToggle,
        clickWindowState,
        mapTypeHandler,
        carPopupClickEvent,
        loadingOnProcess,
        courseExtents,
        historyNoDataPopup,
        actionZoneModified,
        editAzCssCursorToUse,
        editAzCssCursorLastUsed,
        isMouseOverPolygon,
        isDrawingNewPolygon,
        isMouseOverEdgeOrVertex,
        actionZoneId,
        currentAzClickedOnEditId,
        actionZoneButtonClicked,
        actionZoneAction,
        cancelActionZoneEdit,
        actionZoneRequest,
        saveActionZone,
        deleteActionZone,
        actionZoneVertexCount,
        hideSubNav,
        subNavDataState,
        cpoData,
        shouldInitCpoData,
        polygonSelectedForCpo,
        shouldCallCpoSelected,
        setCPOColor,
        shouldSetCpoColor,
        optionsCPOShowCourses,
        toggleAddActionZonePolygon,
        lastSelectedActionZoneImageId,
        refreshActionZones,
        currentClickedTab
    } = useHookstate(MAP_GLOBAL_STATES);

    const {
        nextMainTabIndex,
        nextMainTabName
    } = useHookstate(COP_GLOBAL_STATES);

    const { detectScreenState, showTagCarsState, findCars } = useHookstate(COMMON_COMPONENTS_STATES);

    const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);

    const dispatch = useDispatch();

    const navigate = useNavigate();

    //#region Action Zones hooks
    const [actionZonesPath, setActionZonesPath] = useState([]);
    const [actionZonesPolygons, setActionZonesPolygons] = useState([]); // array of google.maps.Polygon objects (polygons have extra property object actionZoneInfo)
    const [boundsOfActionZones, setBoundsOfActionZones] = useState(null);
    const [vertexToDeleteIndex, setVertexToDeleteIndex] = useState(-1);
    const [vertexToDeletePath, setVertexToDeletePath] = useState(null);
    const [alertModalTitle, setAlertModalTitle] = useState("");
    const [alertModalContent, setAlertModalContent] = useState("");
    const [alertModalIsOpen, setAlertModalIsOpen] = useState(false);
    const [alertModalValidation, setAlertModalValidation] = useState(false);
    const [alertModalHandleOnSubmit, setAlertModalHandleOnSubmit] = useState(() => { });
    const [alertModalHandleOnClose, setAlertModalHandleOnClose] = useState(() => { });
    const [drawingManager, setDrawingManager] = useState(null);
    const [isDeleteGeofenceAz, setIsDeleteGeofenceAz] = useState(false);

    //#endregion Action Zones hooks

    //This is used on siteMap
    const [boundsOfActionZonesInfo, setBoundsOfActionZonesInfo] = useState({ bounds: boundsOfActionZones, numberOfPositions: 0 });

    const [removeAddPolygon, setRemoveAddPolygon] = useState(false);
    const [displayKmlLayer, setDisplayKmlLayer] = useState();
    const [setting, setSetting] = React.useState({ draggable: true });
    const [CTDListenerAdded, setCTDListenerAdded] = useState(false);
    const [CTDModal, setCTDModal] = useState(false);

    const [isSiteAreaPolygon, setIsSiteAreaPolygon] = useState(false);
    const [isHoleAreaPolygon, setIsHoleAreaPolygon] = useState(false);
    const [siteAreaClickEvent, setSiteAreaClickEvent] = useState();
    const [siteAreaClickEventData, setSiteAreaClickEventData] = useState();
    const [verticesCount, setVerticesCount] = React.useState(0);
    const [sitesetupDialogBox, setSitesetupDialogBox] = useState({});
    const [openAlertModal, setOpenAlertModal] = useState(false);
    const [openModel, setOpenModel] = React.useState(false);
    const [editModel, setEditModel] = React.useState(false);
    const [modalState, setModalState] = React.useState("");
    const [indexId, setIndexID] = React.useState();
    const [isActiveCarList, setActiveCarList] = useState("false");
    const [hoverState, setHoverState] = useState({});
    const [hoverStateHistory, setHoverStateHistory] = useState({});
    const [clickState, setClickState] = useState({});
    const [goClick, setGoClick] = useState(false);
    const [all, setAll] = useState(false);
    const [site, setSite] = useState(true);
    const [tempSiteId, setTempSiteId] = useState("");
    const [tempSiteEdit, setTempSiteEdit] = useState([]);
    const [isTempPolygon, setIsTempPolygon] = useState(false);
    const [open2, setOpen2] = useState(false);
    const handleClose2 = () => setOpen2(false);
    const [mapData, setMap] = useState(null);
    const [mapsData, setMaps] = useState(null);
    const [tempSiteData, setTempSiteData] = useState([]);
    const [dragCenter, setDragCenter] = useState({
        center: { lat: 30.20223435690779, lng: -81.39747201448188 },
    });
    const [courseTypeModel, setCourseTypeModel] = useState(1);
    const [newPosition] = useState();
    const [polyLineState, setPolyLineState] = useState([]);
    const [carTrackPolyLineState, setCarTrackPolyLineState] = useState([]);
    let [teesZoneState, setTeesZoneState] = useState();
    let [gmsZoneState, setGmsZoneState] = useState();
    let [fwysZoneState, setFwysZoneState] = useState();
    let [extsZoneState, setExtsZoneState] = useState();
    const [actionZonePoints, setActionZonePoints] = useState([]);
    const [cogDistan] = useState("");
    const [addCogDistan] = useState(0);
    const [drawAreaPolygon, setDrawAreaPolygon] = useState();
    const [holeCount, setHoleCount] = useState(null);
    const [siteDrawAreaPolygon, setSiteDrawAreaPolygon] = useState();
    const [saveErrorModal, setSaveErrorModal] = useState(false);
    const [holeNoModel, setHoleNoModel] = useState(1);
    const [tempPolygon, setTempPolygon] = useState([]);
    const [isHole, setIsHole] = useState(false);
    const [isEditHole, setIsEditHole] = useState(false);
    const [courseNameModel, setCourseNameModel] = useState(1);
    const [markers] = useState([]);
    const [showHoleMarker, setShowHoleMarker] = useState(true);
    const [centerGreenDataState, setCenterGreenDataState] = useState([]);
    const [teeMarkersDataState, setTeeMarkersDataState] = useState([]);
    const [teeMarkeSeetingId, setTeeMarkerSeetingId] = useState([]);
    const [openAreaWindow, setOpenAreaWindow] = useState(false);
    const [openSiteAreaWindow, setOpenSiteAreaWindow] = useState(false);
    const [dialogCancelValue, setDialogCancelValue] = useState("");
    const [pointsOfInterestDataState, setPointsOfInterestDataState] = useState([]);
    const [newMarker, setNewMarker] = useState();
    const [siteSetupState, setSiteSetupState] = useState([]);
    const [ourData, setOurData] = useState({
        tee: [],
        poi: [],
        cog: [],
    });
    const [editState, seteditState] = useState({
        editStage: false,
        polygonType: null,
    });
    const [teeHoleNumbers] = useState([]);
    const [poiHoleNumbers] = useState([]);
    const [deleteId, setDeleteId] = useState(0);
    const [editId, setEditId] = useState(0);
    const [areaPolygons, setAreaPolygons] = useState([]);
    const [holePolygons, setHolePolygons] = useState([]);
    const [snackbarState, setSnackbarState] = React.useState({
        openSnackbar: false,
        vertical: "bottom",
        horizontal: "right",
    });
    const { vertical, horizontal, openSnackbar } = snackbarState;

    const [courseName, setCourseName] = React.useState();
    const [courseEditName, setCourseEditName] = React.useState(1);
    const [holeNo, setHoleNo] = React.useState();
    const [editHoleNo, setEditHoleNo] = React.useState(0);
    const [teeValue, setTeeValue] = React.useState(1323);
    const [teeEditValue, setTeeEditValue] = React.useState(1323);
    const [teeEditCopy, setTeeEditCopy] = React.useState(0);
    const [poiTypeValue, setPoiTypeValue] = React.useState(2);
    const [siteAreaType, setSiteAreaType] = React.useState(0);
    const [poiEditTypeValue, setPoiEditTypeValue] = React.useState(2);
    const [poiEditTypeCopy, setPoiEditTypeCopy] = React.useState(2);
    const [poiPositionValue, setPoiPositionValue] = React.useState(0);
    const [poiEditPositionValue, setPoiEditPositionValue] = React.useState(0);
    const [poiEditPositionCopy, setPoiEditPositionCopy] = React.useState(0);
    const [popupState, setPopupState] = React.useState(false);
    const [editLatLng, setEditLatLng] = React.useState({ lat: 0, lng: 0 });
    const [carHistoryMarkers, setCarHistoryMarkers] = useState([]);
    const [carData, setCarData] = useState([]);
    const [editCogTeePoiSaveActiveButton, setEditCogTeePoiSaveActiveButton] = useState(false);
    const [addCogTeePoiSaveActiveButton, setAddCogTeePoiSaveActiveButton] = useState(false);
    const [siteSetupSaveActiveButton, setSiteSetupSaveActiveButton] = useState(false);
    const [siteAreaSaveActiveButton, setSiteAreaSaveActiveButton] = useState(false);
    const [zoomPosition, setZoomPosition] = useState(null);
    const [carsPosition, setCarsPosition] = useState([]);
    const [allCarData, setAllCarData] = useState([]);
    const [carLocationActivated, setCarLocationActivated] = useState(false);
    const [carSnackbarInfo, setCarSnackbarInfo] = useState({
        lat: "",
        lng: "",
    });

    const [finalDataState, setFinalDataState] = useState();

    // teesBtn
    const [teesAreaPathState, setTeesAreaPathState] = useState();
    const [teesPathCoordsState, setTeesPathCoords] = useState();
    const [teesZoneDisplayed, setTeesZoneDisplayed] = useState([]);

    // gmsBtn
    const [gmsAreaPathState, setGmsAreaPathState] = useState();
    const [gmsPathCoordsState, setGmsPathCoords] = useState();
    const [gmsZoneDisplayed, setGmsZoneDisplayed] = useState([]);

    //fwysBtn
    const [fwysAreaPathState, setFwysAreaPathState] = useState();
    const [fwysPathCoordsState, setFwysPathCoords] = useState();
    const [fwysZoneDisplayed, setFwysZoneDisplayed] = useState([]);

    //extsBtn
    const [extsAreaPathState, setExtsAreaPathState] = useState();
    const [extsPathCoordsState, setExtsPathCoords] = useState();
    const [extsZoneDisplayed, setExtsZoneDisplayed] = useState([]);

    const [stgsAreaPathState, setStgsAreaPathState] = useState();
    const [stgsPathCoordsState, setStgsPathCoords] = useState();
    const [stgsZoneDisplayed, setStgsZoneDisplayed] = useState([]);
    const [editSelectedData, setEditSelectedData] = useState();
    const [notAvailableCars, setNotAvailableCars] = useState([]);
    const [openErrorModal, setOpenErrorModal] = useState(false);
    const [openPopupNotAvailableCars, setOpenPopupNotAvailableCars] = useState(false);

    const [heightMapOverlayView, setHeightMapOverlayView] = useState(null);
    const [heightMapInfo, setHeightMapInfo] = useState([]);
    const [openHeightMapModal, setOpenHeightMapModal] = useState(false);
    const [isHeightMapShowing, setIsHeightMapShowing] = useState(false);
    const opacityContainerRef = useRef(null);
    const opacitySliderRef = useRef(null);

    const CTDStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        maxWidth: "400px",
        width: "100%",
        bgcolor: "#fff",
        borderRadius: "5px",
        overflow: "hidden",
    };

    const historyModalStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        maxWidth: "400px",
        width: "calc(100% -  40px)",
        bgcolor: "#fff",
        borderRadius: "5px",
        overflow: "hidden",
    };
    const popUpStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        maxWidth: "600px",
        width: "100%",
        bgcolor: "rgb(255, 255, 255)",
        borderRadius: "5px",
        overflow: "hidden",
    };
    let specs = specificCarTrackHistory.get();

    useEffect(() => {
        if (siteId.get()) {
            dispatch(COMMON_SERVICES.getKmlLayerService(siteId.get()));
            dispatch(COMMON_SERVICES.getHoleMarkerServices(siteId.get()));
            dispatch(COMMON_SERVICES.getActionZoneServices(siteId.get()));
            dispatch(COMMON_SERVICES.getCarServices(true, siteId.get()));
            dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
            dispatch(COMMON_SERVICES.getMapImageServices(siteId.get()));
            dispatch(COMMON_SERVICES.getVisageUsersList());
            dispatch(COMMON_SERVICES.getRolesListServices());
            dispatch(COMMON_SERVICES.getPrivilegesListServices());
            dispatch(COMMON_SERVICES.getVisageUsersServices());
        }

        addSiteSetup.set(false);
        setHoleCount(null);

        if (heightMapOverlayView != null) {
            heightMapOverlayView.hide();
        }

        heightMapToggle.set(false);
        setOpenHeightMapModal(false);
        setIsHeightMapShowing(false);
        setHeightMapOverlayView(null);
        setHeightMapInfo("");
    }, [siteId.get()]);

    //#region Action zones useEffects

    //When changing tabs, make sure to reload action zones
    useEffect(() => {
        if (mapSideNavTabState.get() === "Action Zones" || mapSideNavTabState.get() === "CPO") {
            dispatch(COMMON_SERVICES.getActionZoneServices(siteId.get()));
        }
    }, [mapSideNavTabState.get()]);

    useEffect(() => {
        if (getCarPathActionZone && (mapSideNavTabState.get() === "Action Zones" || mapSideNavTabState.get() === "CPO")) {
            let localGetCarPathActionZone = getCarPathActionZone;

            //If geofence was deleted then remove it from the array
            if (isDeleteGeofenceAz) {
                localGetCarPathActionZone = getCarPathActionZone.filter(x => x.IsGeofence == false)
            }

            setActionZonesPath(localGetCarPathActionZone);
        }
    }, [getCarPathActionZone]);

    useEffect(() => {
        if (actionZonesPath?.length > 0 && mapsData && (mapSideNavTabState.get() === "Action Zones" || mapSideNavTabState.get() === "CPO")) {
            //initialize
            if (siteSettingsData) {
                getCourseExtents(siteSettingsData, mapsData, courseExtents);

                // set the multiple courses flag
                if (siteSettingsData?.Courses?.length > 1) {
                    optionsCPOShowCourses.set(true);
                }
            }

            initActionZones();
            processActionZones();
        }

        localStorage.setItem("actionZoneButton", mapSideNavTabState.get() === "Action Zones");
    }, [actionZonesPath, mapsData]);

    useEffect(() => {
        if (mapsData && mapData) {
            setDrawingManager(new mapsData.drawing.DrawingManager({
                map: mapData,
                drawingControl: false, // true shows icons to add new polygon
                drawingControlOptions: {
                    position: mapsData.ControlPosition.TOP_CENTER,
                    drawingModes: [mapsData.drawing.OverlayType.POLYGON], // array of supported drawing modes
                },
                polygonOptions: {
                    strokeColor: getActionZoneColor(actionZoneTypes.NoSpeedRestriction),
                    strokeOpacity: 0.9,
                    strokeWeight: 2,
                    fillColor: newPolyFillColor, // so user can see new ones that haven't been saved yet
                    fillOpacity: 0.45,
                    clickable: true, // set this to true if wiring click event on the polygon
                    editable: true,
                },
            }));
        }
    }, [mapsData, mapData]);

    useEffect(() => {
        if (mapsData && mapData) {
            mapsData.event.addListener(drawingManager, "overlaycomplete", function (event) {
                setActionZonesPolygons(prevPolygons => {
                    let localActionZonesPolygons = prevPolygons.slice();

                    if (addActionZonePolygon.get() && getPolygonVertices(event.overlay).length > 2) {
                        event.overlay.actionZoneInfo = getNewActionZoneInfo(); // event.overlay is the new polygon
                        localActionZonesPolygons.push(event.overlay);
                        actionZoneSelected(event.overlay, true);
                        event.overlay.actionZoneBuffer = addPolyline(event.overlay.actionZoneInfo);
                        setPolygonListeners(event.overlay);

                        actionZoneModified.set(true);
                        editActionZonePolygonData.set(event.overlay);
                    } else {
                        event.overlay.setMap(null);
                        event.overlay = null;
                    }

                    processActionZones(localActionZonesPolygons);

                    drawingManager.setDrawingMode(null);
                    isDrawingNewPolygon.set(false);

                    return localActionZonesPolygons; // Return the updated polygons array
                });
            });
        }
    }, [drawingManager]);

    //When zooming in or out of the map we change the action zone buffer polygon stroke width and change the cursor if needed
    useEffect(() => {
        if (mapData && actionZonesPolygons?.length) {
            var strokeWidth = actionZoneBufferWidth[mapData.getZoom() - 1];

            //Changes the cursor
            selectEditAzPolygonCursor(true);

            // update the AZ buffer width
            for (var p = 0; p < actionZonesPolygons.length; p++) {
                if (actionZonesPolygons[p].actionZoneBuffer) {
                    actionZonesPolygons[p].actionZoneBuffer.setOptions({
                        strokeWeight: strokeWidth
                    });
                }
            }
        }

        setZoomPosition(mapData?.getZoom());
    }, [mapData?.getZoom()]);

    //This handles when user clicks on Action Zone Control buttons (messages, control, car path only and geofence)
    useEffect(() => {
        var buttonFunc;

        //I want this to be called only when Control button is clicked and not on the first render as well
        if (Object.keys(actionZoneButtonClicked).length > 0) {
            switch (actionZoneButtonClicked.get()) {
                case "messages":
                    buttonFunc = closeActionZoneEditsOnMessage;
                    break;
                case "control":
                    buttonFunc = closeActionZoneEditsOnControl;
                    break;
                case "carpathonly":
                    buttonFunc = closeActionZoneEditsOnCarPathOnly;
                    break;
                case "geofence":
                    buttonFunc = closeActionZoneEditsOnGeofence;
                    break;
            }

            if (checkActionZoneModified()) {
                setDiscardModalOnLeave(buttonFunc);
            }
            else {
                buttonFunc();
            }
        }
    }, [actionZoneButtonClicked.get()]);

    useEffect(() => {
        if (refreshActionZones.get()) {
            if (checkActionZoneModified()) {
                setDiscardModalOnLeave(onTabChangeAzDiscardChanges);
            }

            refreshActionZones.set(false);
        }
    }, [refreshActionZones.get()]);

    //Every time we press action zones buttons (message, control, car path only and geofence) or click on cpo tab, re process action zones
    useEffect(() => {
        if (actionZonesPath?.length > 0 && mapsData) {
            if (mapSideNavTabState.get() === "Action Zones" || mapSideNavTabState.get() === "CPO") {
                processActionZones();
            } else {
                closeActionZoneEdits();
                cleanUpActionZone(); // remove existing action zones from map
                updateActionZoneBounds();
            }
        }
    }, [messageActionZone.get(), controlsActionZone.get(), cartPathActionZone.get(), geofenceActionZone.get()]);

    //Handles adding new action zone
    useEffect(() => {
        if (toggleAddActionZonePolygon.get() != null) {
            if (checkActionZoneModified()) {
                setDiscardModalOnLeave(handleAddActionZoneButton);
            }
            else {
                handleAddActionZoneButton();
            }
        }
    }, [toggleAddActionZonePolygon.get()]);

    //Handles when user clicks on deactive action zones
    useEffect(() => {
        if (toggleDeactiveAllAction.get() != null) {
            processActionZones();
        }
    }, [toggleDeactiveAllAction.get()]);

    useEffect(() => {
        if (Object.keys(editActionZonePolygonData).length > 0) {
            var colorFill = 'LightGray';

            if (isEnabledActionZone.get()) {
                colorFill = getActionZoneColor(editActionZonePolygonData.get().actionZoneInfo.Type, false);
            }

            if (!siteSettingsData.ActionZones) {
                colorFill = 'transparent';
            }

            var polygon = getSettablePolygon(editActionZonePolygonData.get().actionZoneInfo.Id);

            if (polygon) {
                polygon.setOptions({
                    fillColor: colorFill
                });
            }
        }
    }, [isEnabledActionZone.get()]);

    useEffect(() => {
        if (Object.keys(editActionZonePolygonData).length > 0) {
            var color = getActionZoneColor(actionZoneAction.get(), false);
            var colorFill = color;

            if (!isEnabledActionZone.get()) {
                colorFill = 'LightGray';
            }

            if (editActionZonePolygonData.get().actionZoneInfo.IsNew) {
                colorFill = newPolyFillColor; // so user can see new ones that haven't been saved yet
            }

            if (!siteSettingsData.ActionZones) {
                color = 'white';
                colorFill = 'transparent';
            }

            var polygon = getSettablePolygon(editActionZonePolygonData.get().actionZoneInfo.Id);

            if (polygon) {
                polygon.setOptions({
                    strokeColor: color,
                    fillColor: colorFill
                });
            }
        }
    }, [actionZoneAction.get()]);

    useEffect(() => {
        if (!openActionZoneWindow.get()) {
            let zones = actionZonesPolygons.map((item) => {
                item?.setOptions({ editable: false });
                return item;
            });
            setActionZonesPolygons(zones);
        }
    }, [openActionZoneWindow.get()]);

    useEffect(() => {
        if (Object.keys(editActionZonePolygonData).length > 0) {
            if (checkActionZoneModified()) {
                setDiscardModalOnLeave(handleCancelEditActionZone);
            } else {
                stopActionZonePanel();
            }

            addActionZonePolygon.set(false);
        }
    }, [cancelActionZoneEdit.get()]);

    //Handles Save Action Zone button
    useEffect(() => {
        if (Object.keys(actionZoneRequest).length > 0) {
            let localActionZoneRequest = { ...actionZoneRequest.get() };

            let poly = editActionZonePolygonData?.get();
            let actionZoneInfo = poly?.actionZoneInfo;
            let IsNew = actionZoneInfo?.IsNew;

            localActionZoneRequest.SiteId = siteId.get();

            if (IsNew) {
                //The version assigned below is the version of the definition of data the makes up a serialized AZ (we are currently on 1).
                localActionZoneRequest.version = 1; // For now new Action Zones must always have a Version of 1 for AZ Serialization to work correctly.
            }

            if (localActionZoneRequest) {
                delete localActionZoneRequest.IsNew; // remove property that is not really part of the Action Zone

                var currentActionZonePolygonVertices = getPolygonVertices(poly);

                if (currentActionZonePolygonVertices?.length >= 2) {
                    // clear the scratch AZ vertices, and don't save the AZ if the length is 0
                    localActionZoneRequest.AzVertexes = [];

                    // Get the current vertices for this AZ
                    for (var v = 0; v < currentActionZonePolygonVertices.length; v++) {
                        localActionZoneRequest.AzVertexes.push({
                            Id: 0, // for some reason the Id was always 0 in the original returned data
                            Latitude: currentActionZonePolygonVertices[v].lat(),
                            Longitude: currentActionZonePolygonVertices[v].lng(),
                        });
                    }
                    // need to re-add first point (data from system duplicates starting and ending points)
                    var startIndex = 0;
                    if (localActionZoneRequest.IsGeofence)
                        startIndex = 2; // for Geofence, 1st two points are UL/LR of site extents, actual polygon starts on 3rd point

                    localActionZoneRequest.AzVertexes.push({
                        Id: 0, // for some reason the Id was always 0 in the original returned data
                        Latitude: currentActionZonePolygonVertices[startIndex].lat(),
                        Longitude: currentActionZonePolygonVertices[startIndex].lng(),
                    });
                }

                // if there are other AZs for this course and hole, match the enable setting
                let currentEditAzData = { ...editActionZonePolygonData.get() };
                for (var i = 0; i < actionZonesPath.length; i++) {
                    if (actionZonesPath[i].Hole > 0) {
                        if (actionZonesPath[i].Course === localActionZoneRequest.Course && actionZonesPath[i].Hole === localActionZoneRequest.Hole) {
                            localActionZoneRequest.IsEnabled = actionZonesPath[i].IsEnabled;
                            currentEditAzData.IsEnabled = actionZonesPath[i].IsEnabled;
                            editActionZonePolygonData.set(currentEditAzData);

                            break; // one match is enough
                        }
                    }
                }

                if (IsNew) {
                    localActionZoneRequest.IsEnabled = localActionZoneRequest.IsCartPathOnly ? true : localActionZoneRequest.IsEnabled;

                    dispatch(COMMON_SERVICES.addActionZoneServices(localActionZoneRequest, siteId.get()))
                        .then((result) => {
                            loadingOnProcess.set(false);

                            if (result) {
                                dispatch(COMMON_SERVICES.getActionZoneServices(siteId.get()));

                                addActionZonePolygon.set(false);
                                actionZoneModified.set(false);
                                editActionZonePolygonData.set(null);
                            } else {
                                errorSavingAzModal();
                            }
                        });

                    openActionZoneWindow.set(false);
                } else {
                    let payload = {
                        existingActionZone: getCarPathActionZone.find((a) => a.Id === actionZoneId.get()),
                        modifiedActionZone: localActionZoneRequest,
                    };

                    let zoneId = actionZoneId.get();
                    dispatch(
                        COMMON_SERVICES.editActionZoneServices(zoneId, siteId.get(), payload)
                    ).then((result) => {
                        loadingOnProcess.set(false);
                        if (result) {
                            actionZoneId.set(0);
                            actionZoneModified.set(false);
                            editActionZonePolygonData.set(null);

                            dispatch(COMMON_SERVICES.getActionZoneServices(siteId.get()));
                        } else {
                            errorSavingAzModal();
                        }
                    });

                    openActionZoneWindow.set(false);
                }
            } else {
                errorSavingAzModal();
            }

            actionZoneRequest.set(null);
        }
    }, [saveActionZone.get()]);

    useEffect(() => {
        if (deleteActionZone.get() != null) {
            if (vertexToDeletePath && vertexToDeleteIndex > -1) {
                const updatedVertexToDeletePath = [...vertexToDeletePath];
                updatedVertexToDeletePath.splice(vertexToDeleteIndex, 1);

                setVertexToDeletePath(updatedVertexToDeletePath);
            } else if (editActionZonePolygonData.get()?.actionZoneInfo?.IsGeofence && !deleteActionZone.get()) {
                setAlertModalHandleOnSubmit(() => onResetGeofenceSubmit);
                setAlertModalTitle(t("Confirm"));
                setAlertModalContent(`${t("Reset_the_Geofence_to_the_course_extents?")}?`);
                setAlertModalIsOpen(true);
                setAlertModalValidation(false);
            } else {
                if (editActionZonePolygonData.get()?.actionZoneInfo?.IsNew) {
                    // if this is a new Action Zone, it is not yet in the database...
                    stopActionZonePanel();
                } else if (actionZoneId.get() != 0) {
                    dispatch(COMMON_SERVICES.deleteActionZoneServices(actionZoneId.get(), siteId.get()))
                        .then((result) => {
                            if (result) {
                                deleteActionZonePoly(getActionZonePolygonArrayIndexById(actionZoneId.get()));

                                let index = getActionZoneArrayIndexById(actionZoneId.get());
                                if (index !== -1 && actionZonesPath?.length) {
                                    const localActionZonesPath = [...actionZonesPath];
                                    localActionZonesPath.splice(index, 1);

                                    setActionZonesPath(localActionZonesPath);
                                }

                                if (editActionZonePolygonData?.get()?.actionZoneInfo?.IsGeofence) {
                                    setIsDeleteGeofenceAz(true);
                                    setAlertModalTitle("Geofence deleted");
                                    setAlertModalContent(`Refresh page to recreate geofence`);
                                    setAlertModalIsOpen(true);
                                    setAlertModalValidation(true);
                                }

                                stopActionZonePanel();
                                openActionZoneWindow.set(false);
                            }
                        });
                }
            }

            deleteActionZone.set(null);
            loadingOnProcess.set(false);
            actionZoneModified.set(false);
            hideDeleteVertexElement();
        }
    }, [deleteActionZone.get()]);

    //This is sets cpo color for CarPath.jsx
    useEffect(() => {
        if (shouldSetCpoColor.get()) {
            // Set the correct color for the CPO action zone
            var colorFill = "LightGray";

            setCPOColor.get()?.forEach(element => {
                if (element?.IsEnabled) {
                    colorFill = getActionZoneColor(element?.Type, false);
                }

                var polygon = getSettablePolygon(element?.Id);

                polygon.setOptions({
                    fillColor: colorFill
                });
            });

            shouldSetCpoColor.set(false);
        }
    }, [shouldSetCpoColor.get()]);

    //#endregion End of Action Zones useEffects

    //#region Site Setup useEffects 

    // setting save button active for edit popup modal
    useEffect(() => {
        if (mapData && mapsData)
            handleGoogleMapApis(mapData, mapsData);
    }, [mapData, mapsData]);

    useEffect(() => {
        setEditCogTeePoiSaveActiveButton(false);
        setAddCogTeePoiSaveActiveButton(false);
        setSiteSetupSaveActiveButton(false);
        if (isNewEditPolygon() && editSiteSetup.get()) {
            setSiteSetupSaveActiveButton(true);
        } else if (!isNewEditPolygon()) {
            areaModified.set(false);
        }
        if ((isNewEditPoi() || isNewEditTee() || isNewEditCog()) && editSiteSetup.get()) {
            setEditCogTeePoiSaveActiveButton(true);
        }
        if (addSiteSetup.get()) {
            setEditCogTeePoiSaveActiveButton(true);
            setAddCogTeePoiSaveActiveButton(true);
            setSiteSetupSaveActiveButton(true);
            setSiteAreaSaveActiveButton(true);
        }
    }, [courseName,
        holeCount,
        teeValue,
        editHoleNo,
        poiEditPositionValue,
        poiEditTypeValue,
        holeNo,
        courseEditName,
        tempPolygon,
        verticesCount,
        teeEditValue,
        holeNoModel,
        courseNameModel,
        courseTypeModel,
        addSiteSetup.get(),
    ]);

    useEffect(() => {
        if (addSiteSetup.get()) {
            showAreas.set(!showAreas.get());
            setTimeout(() => {
                showAreas.set(!showAreas.get());
            }, 0);
            setOpenSiteAreaWindow(false);
            showSiteData.set(true);
            setSiteSetupState(siteSetupData);

            if (isSaveSiteArea.get()) {
                areaPolygons.forEach((it) => it.setMap(null));
                siteAreaDrawingEventListenerAdding();
            }

            if (isSaveHoleArea.get()) {
                setTempPolygon([]);
                holePolygons.forEach((it) => it.setMap(null));
                resetHoleAreaForm();
                holeAreaDrawingEventListenerAdding();
            }

            isSaveSiteArea.set(false);
            isSaveHoleArea.set(false);
        }
    }, [siteSetupData]);

    useEffect(() => {
        if (editSiteSetup.get()) {
            showSiteData.set(true);
            setSiteSetupState(siteSetupData);
            setTempSiteEdit([]);
            setIsTempPolygon(false);

            let siteIdValue = siteId.get();

            let imageData = {
                courseNumber: courseNameModel,
                holeNumber: holeNoModel,
                siteIdValue,
            };
            imagePreview({}, imageData, {});
            showAreas.set(!showAreas.get());
            setTimeout(() => {
                showAreas.set(!showAreas.get());
            }, 0);
            areaModified.set(false);
            editSelectedData?.setOptions({
                editable: false,
                fillOpacity: 0.6,
            });

            if (isSaveSiteArea.get()) {
                setOpenSiteAreaWindow(false);
            }

            if (isSaveHoleArea.get()) {
                setOpenAreaWindow(false);
                resetHoleAreaForm();
            }

            isSaveSiteArea.set(false);
            isSaveHoleArea.set(false);
        }
    }, [siteSetupData]);

    useEffect(() => {
        if (removeAddPolygon) {
            drawAreaPolygon.setMap(null);
        }
    }, [drawAreaPolygon]);

    useEffect(() => {
        const configList = [
            {
                btn: teesBtn,
                areaPathState: teesAreaPathState,
                pathCoordsState: teesPathCoordsState,
                zoneDisplayed: teesZoneDisplayed,
                setZoneDisplayed: setTeesZoneDisplayed,
                color: "#eb0c0a",
                id: 2
            },
            {
                btn: gmsBtn,
                areaPathState: gmsAreaPathState,
                pathCoordsState: gmsPathCoordsState,
                zoneDisplayed: gmsZoneDisplayed,
                setZoneDisplayed: setGmsZoneDisplayed,
                color: "#067c05",
                id: 3
            },
            {
                btn: fwysBtn,
                areaPathState: fwysAreaPathState,
                pathCoordsState: fwysPathCoordsState,
                zoneDisplayed: fwysZoneDisplayed,
                setZoneDisplayed: setFwysZoneDisplayed,
                color: "#f0f004",
                id: 4
            },
            {
                btn: extsBtn,
                areaPathState: extsAreaPathState,
                pathCoordsState: extsPathCoordsState,
                zoneDisplayed: extsZoneDisplayed,
                setZoneDisplayed: setExtsZoneDisplayed,
                color: "#0202f2",
                id: 1
            },
            {
                btn: stgsBtn,
                areaPathState: stgsAreaPathState,
                pathCoordsState: stgsPathCoordsState,
                zoneDisplayed: stgsZoneDisplayed,
                setZoneDisplayed: setStgsZoneDisplayed,
                color: "#663a83",
                id: 5
            }
        ];

        configList.forEach(config => {
            displayHideAreaPolygon(
                config.btn.get(),
                config.areaPathState,
                config.pathCoordsState,
                config.zoneDisplayed,
                config.setZoneDisplayed,
                config.color,
                config.id,
                mapData,
                mapsData,
                addListenersOnEditSiteAreaChangesPolygon,
                addListenersOnEditSiteAreaFinalPolygon,
                addListenersOnEditAreaFinalPolygon,
                polygonClick,
                polyMouseOver,
                polyMouseOut,
                showAreas.get()
            );
        });
    }, [
        teesBtn.get(),
        gmsBtn.get(),
        fwysBtn.get(),
        extsBtn.get(),
        stgsBtn.get(),
        showAreas.get()
    ]);

    useEffect(() => {
        if (!holeChange.get()) callPolygonForSiteSetup();
    }, [hideAll.get(), showAll.get(), showAreas.get()]);

    useEffect(() => {
        if (holeChange.get() && showAreas.get()) {
            const polyTypes = ["exts", "tees", "gms", "fwys"];
            const color = ["#0202f2", "#eb0c0a", "#067c05", "#f0f004"];

            polyTypes.map((item, i) =>
                hidePolygon(
                    eval(item + "ZoneDisplayed"),
                    eval(
                        "set" +
                        item.charAt(0).toUpperCase() +
                        item.slice(1) +
                        "ZoneDisplayed"
                    )
                )
            );

            polyTypes.map((item, i) => {
                if (
                    (item === "exts" && extsBtn.get()) ||
                    (item === "tees" && teesBtn.get()) ||
                    (item === "gms" && gmsBtn.get()) ||
                    (item === "fwys" && fwysBtn.get())
                ) {
                    displayPolygon(
                        eval(item + "AreaPathState"),
                        eval(item + "PathCoordsState"),
                        eval(
                            "set" +
                            item.charAt(0).toUpperCase() +
                            item.slice(1) +
                            "ZoneDisplayed"
                        ),
                        color[i],
                        i + 1,
                        mapData,
                        mapsData,
                        addListenersOnEditSiteAreaChangesPolygon,
                        addListenersOnEditSiteAreaFinalPolygon,
                        addListenersOnEditAreaFinalPolygon,
                        polygonClick,
                        polyMouseOver,
                        polyMouseOut
                    );
                }
            });
        }
    }, [fwysAreaPathState]);

    useEffect(() => {
        if (mapSideNavTabState.get() !== "Site Setup" || editSiteSetup.get()) {
            setOpenAreaWindow(false);
            setOpenSiteAreaWindow(false);
            cancelMarkers();
            addSiteSetup.set(false);

            areaModified.set(false);
            setTempPolygon([]);
            siteDrawAreaPolygon?.setDrawingMode(mapsData.drawing.OverlayType.FALSE);
            siteDrawAreaPolygon?.setMap(null);
            drawAreaPolygon?.setDrawingMode(mapsData.drawing.OverlayType.FALSE);
            drawAreaPolygon?.setMap(null);
            areaPolygons.forEach((it) => it.setMap(null));
            holePolygons.forEach((it) => it.setMap(null));
        }
    }, [mapSideNavTabState.get(), editSiteSetup.get(), subNavDataState.get()]);

    useEffect(() => {
        setSiteSetupState([siteSetupData]);
        callPolygonForSiteSetup();
    }, [siteSetupData]);

    useEffect(() => {
        editActionZonePolygonData.set(null);
        setOpenSiteAreaWindow(false);
        setOpenAreaWindow(false);
        setOpenModel(false);
        actionZoneModified.set(false);
        cancelMarkers();
    }, [siteId.get()]);

    useEffect(() => {
        if (selectSite.get()) {
            setEditModel(false);
            setOpenModel(false);
            setOpenAreaWindow(false);
            setOpenSiteAreaWindow(false);
            addSiteSetup.set(false);

            holePolygons.forEach((it) => it.setMap(null));
            areaPolygons.forEach((it) => it.setMap(null));
        }
    }, [selectSite.get()]);

    useEffect(() => {
        teeMarkersDataState?.map((el) => {
            return teeHoleNumbers.push(el?.Hole);
        });

        pointsOfInterestDataState?.map((el) => {
            return poiHoleNumbers.push(el?.Hole);
        });
    }, [teeMarkersDataState, pointsOfInterestDataState]);

    useEffect(() => {
        detectScreenState.set("map");
        showTagCarsState.set(false);
    }, []);

    useEffect(() => {
        if (AreaFilterData != null) {
            setSiteSetupState([AreaFilterData]);
        }
    }, [AreaFilterData]);

    useEffect(() => {
        if (holeView.get()) showAll.set(true);
    }, [extsPathCoordsState]);

    useEffect(() => {
        if (refreshSiteSetupAreas.get()) {
            showAreas.set(!showAreas.get());
            setTimeout(() => {
                showAreas.set(!showAreas.get());
            }, 30);
        }
        refreshSiteSetupAreas.set(false);
    }, [refreshSiteSetupAreas.get()]);

    useEffect(() => {
        setCenterGreenDataState(siteSetupState[0]?.HoleDatas);
        setTeeMarkersDataState(siteSetupState[0]?.TeeMarkers);
        setPointsOfInterestDataState(siteSetupState[0]?.PointsOfInterest);
        setTeeMarkerSeetingId(siteSetupState[0]?.TeeMarkerSettings);

        if (mapData && mapsData)
            handleGoogleMapApis(mapData, mapsData);
    }, [siteSetupState]);

    useEffect(() => {
        if (!siteLocationGlobalData.get() && mapData && mapsData) {
            defaultProps.center.lat = undefined;
            defaultProps.center.lng = undefined;
        }
    }, [siteLocationGlobalData.get()]);

    useEffect(() => {
        if (site && mapData && mapsData) {
            getMapBoundsForSite(mapData, mapsData, siteSettingsData);
        }
    }, [site]);

    useEffect(() => {
        if (mapSideNavTabState.get() !== "Site Setup" || editSiteSetup.get() === true) {
            setOpenAreaWindow(false);
            setOpenSiteAreaWindow(false);
            cancelMarkers();
            addSiteSetup.set(false);

            areaModified.set(false);
            setTempPolygon([]);
            siteDrawAreaPolygon?.setDrawingMode(mapsData.drawing.OverlayType.FALSE);
            siteDrawAreaPolygon?.setMap(null);
            drawAreaPolygon?.setDrawingMode(mapsData.drawing.OverlayType.FALSE);
            drawAreaPolygon?.setMap(null);
            areaPolygons.forEach((it) => it.setMap(null));
            holePolygons.forEach((it) => it.setMap(null));
        }
    }, [mapSideNavTabState.get(), editSiteSetup.get(), subNavDataState.get()]);

    useEffect(() => {
        if (addSiteSetup.get()) {
            siteAreaDrawingEventListenerAdding();
            holeAreaDrawingEventListenerAdding();

            // resetting newly added polygon
            setCourseNameModel(1);
            setHoleNoModel(1);
            setCourseTypeModel(1);
        } else {
            mapData?.setOptions({
                draggableCursor: "grab",
                draggingCursor: "grabbing",
            });

            siteDrawAreaPolygon?.setDrawingMode(mapsData.drawing.OverlayType.FALSE);
            siteDrawAreaPolygon?.setMap(null);

            drawAreaPolygon?.setDrawingMode(mapsData.drawing.OverlayType.FALSE);
            drawAreaPolygon?.setMap(null);

            areaPolygons.forEach((it) => it.setMap(null));
            holePolygons.forEach((it) => it.setMap(null));
        }
    }, [addSiteSetup.get()]);

    useEffect(() => {
        if (!editSiteSetup.get()) {
            setEditModel(false);
            setOpenAreaWindow(false);
            setOpenSiteAreaWindow(false);
            setEditSelectedData((prevData) => {
                prevData?.setOptions({
                    editable: false,
                    fillOpacity: 0.2,
                });
            });
        }
    }, [editSiteSetup.get()]);

    useEffect(() => {
        if (!editSiteSetup.get() || !showAreas.get()) {
            setOpenAreaWindow(false);
            setOpenSiteAreaWindow(false);
        }
        if (!showAreas.get() && addSiteSetup.get()) {
            areaPolygons.forEach((it) => it.setMap(null));
            holePolygons.forEach((it) => it.setMap(null));
        }
    }, [showAreas.get()]);

    useEffect(() => {
        areaPolygons?.forEach((it) => {
            it?.setOptions({
                options: {
                    editable: true,
                    clickable: false,
                    strokeColor: "#663a83",
                    fillOpacity: 0.2,
                    strokeWeight: 2,
                    fillColor: "#663a83",
                },
            });
            addListenersOnEditSiteAreaFinalPolygon(it);
        });
    }, [areaPolygons]);

    useEffect(() => {
        holePolygons?.forEach((it) => {
            it?.setOptions({
                options: {
                    editable: true,
                    suppressUndo: true,
                    clickable: false,
                    strokeColor: "#00FF00",
                    fillOpacity: 0.2,
                    strokeWeight: 2,
                    fillColor: "red",
                    cursor: "crosshair",
                },
            });
            addListenersOnEditAreaFinalPolygon(it);
        });
    }, [holePolygons]);

    //#endregion Site Setup useEffects 

    useEffect(() => {
        if (mapsData && mapImageData && Object.keys(mapImageData)?.length > 0 && opacityContainerRef.current) {
            const bounds = new mapsData.LatLngBounds(
                new mapsData.LatLng(mapImageData.SwLat, mapImageData.SwLng), //Southwest corner
                new mapsData.LatLng(mapImageData.NeLat, mapImageData.NeLng) //Northeast corner
            );

            setHeightMapOverlayView(heightMapOverlay(bounds, mapImageData.Image));
        }
    }, [mapsData, mapData, mapImageData, opacityContainerRef.current]);

    useEffect(() => {
        if (heightMapToggle.get() != null && mapsData && mapData) {
            if (heightMapToggle.get() && heightMapOverlayView != null) {
                heightMapOverlayView.toggle();
            }

            heightMapToggle.set(false);

            mapsData.event.addListener(mapData, "click", function (event) {
                handleHeightMapValues(event);
            });
        }
    }, [heightMapToggle.get()]);

    useEffect(() => {
        if (mapXYPointsData && Object.keys(mapXYPointsData)?.length > 0) {
            const img = document.getElementById("heightMapImage");

            // Create a canvas to extract pixel data
            const canvas = document.createElement('canvas');
            canvas.width = mapImageData.ImageWidth;
            canvas.height = mapImageData.ImageHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            let blueValue = 0;
            if (mapXYPointsData.X >= 0 &&
                mapXYPointsData.Y >= 0 &&
                mapXYPointsData.X < canvas.width &&
                mapXYPointsData.Y < canvas.height) {
                const pixelData = ctx.getImageData(mapXYPointsData.X, mapXYPointsData.Y, 1, 1).data;
                blueValue = pixelData[2];
            }

            const elevationRange = mapImageData.MaxElevation - mapImageData.MinElevation; // 40

            // Map blue value to elevation
            const mappedElevation = mapToElevation(blueValue, mapImageData.MinElevation, elevationRange);

            const updatedInfoArray = heightMapInfo;

            if (updatedInfoArray.length > 0) {
                updatedInfoArray[2] = `X Pixel: ${mapXYPointsData.X}`;
                updatedInfoArray[3] = `Y Pixel: ${mapXYPointsData.Y}`;
                updatedInfoArray[4] = `Grey scale: ${blueValue}`;
                updatedInfoArray[7] = `Elevation: ${mappedElevation.toFixed(2)} meters`;


                setHeightMapInfo(updatedInfoArray);
                setOpenHeightMapModal(true);
            }
        }
    }, [mapXYPointsData, heightMapInfo]);

    useEffect(() => {
        if (kmlLayerData !== "") {
            let kml =
                mapsData &&
                new mapsData.KmlLayer({
                    url: kmlLayerData,
                    suppressInfoWindows: true,
                    preserveViewport: true,
                    clickable: false,
                    map: mapData,
                });
            setDisplayKmlLayer(kml);
        }
    }, [kmlLayerData, mapData, mapsData]);

    useEffect(() => {
        if (siteLocationGlobalData.get()) {
            setActiveCarList(true);
            drawingManager?.setDrawingMode(mapsData.drawing.OverlayType.FALSE);
            drawingManager?.setMap(null);
        }
    }, [siteLocationGlobalData.get()]);

    useEffect(() => {
        dispatch(kmlLayerDataAction(""));
        displayKmlLayer && displayKmlLayer.setMap(null);
    }, [siteId.get()]);

    useEffect(() => {
        if (overlay.get()) {
            displayKmlLayer && displayKmlLayer.setMap(mapData);
        } else {
            displayKmlLayer && displayKmlLayer.setMap(null);
        }
    }, [overlay.get(), displayKmlLayer]);

    //this use effect will allow user to click AZ after selecting and closing carDetail window options
    useEffect(() => {
        setTimeout(() => {
            if (!clickWindowState.get()) {
                carNumberHover.set(false);
            }
        }, 500);
    }, [clickWindowState.get()]);

    useEffect(() => {
        if (siteId.get() !== null) {
            dispatch(COMMON_SERVICES.getCannedMessagesServices(siteId.get()));
        }
        return () => {
            actionZonesPolygons.forEach((item) => {
                item.setMap(null);
            });
            actionZonesPolygons.length = 0;
        };
    }, []);

    useEffect(() => {
        let localCarData = !Array.isArray(updatedCarData.get()) && typeof updatedCarData.get() === "string" && JSON.parse(updatedCarData.get());

        if (updatedCarData.get() && Array.isArray(localCarData) && localCarData.length !== 0) {
            if (!carLocationActivated) {
                localStorage.setItem("mapCarsSelectAll", "true");
                setCarData([...localCarData]);
                setAllCarData([...localCarData]);
            }
        } else {
            setCarData([]);
            setAllCarData([]);
        }
    }, [updatedCarData.get()]);

    useEffect(() => {
        if (JSON.stringify(carData) !== JSON.stringify(filterCars(
            allCarData,
            mapCarsSelectAll.get(),
            fleetCarsGlobalState.get(),
            marshalCarsGlobalState.get(),
            specialCarsGlobalState.get(),
            memberCarsGlobalState.get(),
            bewrageCarsGlobalState.get(),
            notInUseCarsGlobalState.get(),
            carsNotCommunicatingGlobalState.get(),
            outsidePerimeterGlobalState.get(),
            taggedCarsSaverGlobalState.get(),
            mapsData,
            siteSettingsData,
            getUserRole,
            getHoleAreasState,
            getSiteAreasState,
            getCarPathActionZone
        ))
            && !carLocationActivated
        ) {
            setCarData([
                ...filterCars(
                    allCarData,
                    mapCarsSelectAll.get(),
                    fleetCarsGlobalState.get(),
                    marshalCarsGlobalState.get(),
                    specialCarsGlobalState.get(),
                    memberCarsGlobalState.get(),
                    bewrageCarsGlobalState.get(),
                    notInUseCarsGlobalState.get(),
                    carsNotCommunicatingGlobalState.get(),
                    outsidePerimeterGlobalState.get(),
                    taggedCarsSaverGlobalState.get(),
                    mapsData,
                    siteSettingsData,
                    getUserRole,
                    getHoleAreasState,
                    getSiteAreasState,
                    getCarPathActionZone
                ),
            ]);
        }
    }, [
        mapCarsSelectAll.get(),
        fleetCarsGlobalState.get(),
        marshalCarsGlobalState.get(),
        specialCarsGlobalState.get(),
        memberCarsGlobalState.get(),
        bewrageCarsGlobalState.get(),
        notInUseCarsGlobalState.get(),
        carsNotCommunicatingGlobalState.get(),
        outsidePerimeterGlobalState.get(),
        carData,
        carLocationActivated,
        taggedCarsSaverGlobalState.get()
    ]);

    useEffect(() => {
        if (clickToDriveApiStatus === "success") {
            setTimeout(() => {
                setSnackbarState({ ...snackbarState, openSnackbar: false });
            }, 2000);

            setTimeout(() => {
                dispatch(COMMON_SERVICES.getCarServices(false, siteId.get()));
            }, 3000);
        }
    }, [clickToDriveApiStatus]);

    useEffect(() => {
        return () => {
            isLoading.set(false);
            getCheckedCars.set([
                { carName: "fleetCars", carType: carType.normal, isChecked: true },
                { carName: "marshalCars", carType: carType.marshal, isChecked: false },
                { carName: "bewrageCars", carType: carType.bevcart, isChecked: false },
                { carName: "specialNeedsCars", carType: carType.handicap, isChecked: true },
                { carName: "memberCars", carType: carType.member, isChecked: true },
                { carName: "notCommunicatingCars", carType: carType.notCommunicating, isChecked: false },
                { carName: "notInUseCars", carType: carType.notInUse, isChecked: false },
                { carName: "outsidePerimeterCars", carType: carType.outOfService, isChecked: false },
            ]);
        };
    }, []);

    useEffect(() => {
        if (mapsData && mapData) {
            if (enableClickToDriveFeature.get() && !CTDListenerAdded) {
                mapsData.event.addListener(mapData, "rightclick", function (event) {
                    clickToDrivefeature(event);
                });

                setCTDListenerAdded(true);

                mapData.getDiv().className = "azEditCursorAlias";
            } else if (!enableClickToDriveFeature.get()) {
                mapData.getDiv().className = "azEditCursorDefault";
            }
        }
    }, [enableClickToDriveFeature.get(), mapData, mapsData, CTDListenerAdded]);

    useEffect(() => {
        showSpecifiCarHistory(
            mapData,
            mapsData,
            polyLineState,
            setPolyLineState,
            actionZonePoints,
            setActionZonePoints,
            polyRef,
            actionRef,
            specificCarHistoryData,
            historyOptions.get(),
            polyLinesData,
            carHistoryList,
            getUserRole,
            setHoverStateHistory,
            loadingOnProcess
        );
    }, [specificCarHistoryData, historyOptions.get()]);

    useEffect(() => {
        if (findCars.get()) {
            setAll(false);
            if (mapData && mapsData) {
                handleGoogleMapApis(mapData, mapsData);
            }
        }
    }, [findCars.get()]);

    useEffect(() => {
        if (all) {
            findCars.set(false);
            if (mapData && mapsData) {
                handleGoogleMapApis(mapData, mapsData);
            }
        }
    }, [all]);

    useEffect(() => {
        if (mapInformationData) {
            imageUrl.set(mapInformationData?.Data);
        }
    }, [mapInformationData]);

    useEffect(() => {
        if (getCarTrackData?.length > 0 && mapsData) {
            showSpecifiCarTrackLocation(
                specs
                    ? getCarTrackData.filter((it) => {
                        return (moment.utc(it.LastLocationUpdateInUtc) >= moment.utc(sliderState.get()[0]) &&
                            moment.utc(it.LastLocationUpdateInUtc) <= moment.utc(sliderState.get()[1]));
                    })
                    : [],
                carTrackPolyLineState,
                setCarTrackPolyLineState,
                carHistoryMarkers,
                setCarHistoryMarkers,
                mapData,
                mapsData,
                setHoverState,
                clickState,
                setClickState
            );

            if (getCarTrackData.length > 0 && specs) {
                setCarLocationActivated(true);
                setCarData(
                    allCarData.filter(
                        (item) => item.Car.CarNumber === showTaggedCar.get()
                    )
                );
            } else {
                setCarLocationActivated(false);
            }
        } else if (getCarTrackData.length === 0 && specs) {
            showSpecifiCarTrackLocation(
                [],
                carTrackPolyLineState,
                setCarTrackPolyLineState,
                carHistoryMarkers,
                setCarHistoryMarkers,
                mapData,
                mapsData,
                setHoverState,
                clickState,
                setClickState
            );
            setCarLocationActivated(false);
        }
    }, [getCarTrackData, specs, sliderState.get()[0], sliderState.get()[1]]);

    useEffect(() => {
        if (!specs) {
            setClickState({});
        }
    }, [specs]);

    useEffect(() => {
        if (editState.editStage) {
            let teesZones = teesZoneState?.map((item) => {
                item = item?.setOptions({ editable: false, draggable: false });
            });
            setTeesZoneState(teesZones);

            let fwyszones = fwysZoneState?.map((item) => {
                item = item?.setOptions({ editable: false, draggable: false });
            });
            setFwysZoneState(fwyszones);

            let gmszones = gmsZoneState?.map((item) => {
                item = item?.setOptions({ editable: false, draggable: false });
            });
            setGmsZoneState(gmszones);

            let extszones = extsZoneState?.map((item) => {
                item = item?.setOptions({ editable: false, draggable: false });
            });
            setExtsZoneState(extszones);

            seteditState({ editStage: false, polygonType: null });
        }
    }, [editState]);

    useEffect(() => {
        if (HistoryTypeEnum) {
            selectedHistoryOption.set(
                Object.values(HistoryTypeEnum).find(
                    (it) => it.value === historyOptions.get()
                )
            );
        }
    }, [historyOptions.get()]);

    //#region Action Zones Functions (action zone tab)

    const initActionZones = () => {
        cleanUpActionZone();
        actionZonesPolygons.length = 0;

        if (actionZonesPath) {
            addActionZones();
        } else {
            setActionZonesPath(null);
        }

        if (siteSettingsData) {
            shouldInitCpoData.set(true);
        }
    }

    const errorSavingAzModal = () => {
        setAlertModalTitle(t("Message"));
        setAlertModalContent("Error saving Action Zone");
        setAlertModalIsOpen(true);
        setAlertModalValidation(true);
    }

    const onResetGeofenceSubmit = () => {
        var inPath = createCourseExtentsPolygonPath();
        var outPath = createOutGeofenceVertices(inPath);
        var paths = [outPath, inPath];

        var currentActionZone = getSettablePolygon(editActionZonePolygonData.get().actionZoneInfo.Id);

        currentActionZone.setOptions({
            paths: paths
        });

        currentActionZone.actionZoneBuffer.setOptions({
            path: inPath
        });

        setPolygonListeners(currentActionZone);

        editActionZonePolygonData.set(currentActionZone);
        setAlertModalIsOpen(false);
        actionZoneModified.set(true);
    }

    const cleanUpActionZone = () => {
        // Clear polygons from map
        if (mapData && mapsData && actionZonesPolygons?.length !== 0) {
            actionZonesPolygons.forEach((item) => {
                if (item?.actionZoneBuffer) {
                    item?.actionZoneBuffer?.setMap(null);
                }

                item?.setMap(null);
            });
        }
    }

    const handleAddActionZoneButton = () => {
        addActionZonePolygon.set(!addActionZonePolygon.get());
        editActionZonePolygonData.set({});
        isEnabledActionZone.set(true);
        setAlertModalIsOpen(false);

        setNewActionZonePoly();
        stopActionZonePanel();
    }

    const setDiscardModalOnLeave = (submitFunc, closeFunc) => {
        if (submitFunc) {
            setAlertModalHandleOnSubmit(() => submitFunc);
        } else {
            setAlertModalHandleOnSubmit(() => setAlertModalIsOpen(false));
        }

        if (closeFunc) {
            setAlertModalHandleOnClose(() => closeFunc);
        }

        setAlertModalTitle(t("Confirm"));
        setAlertModalContent(`${t("Discard_changes")}?`);
        setAlertModalIsOpen(true);
        setAlertModalValidation(false);
    }

    const getNewActionZoneInfo = () => {
        return {
            IsNew: true, // not a property of the Action Zone dto so delete it before posting/putting
            Message: "new action zone",
            IsEnabled: true,
            IsEnforcedForMarshal: false,
            IsEnforcedForHandicapped: false,
            IsEnforcedForBeverage: false,
            IsEnforcedForMemberCars: false,
            IsEnforcedForGolf: true,
            EnforceTimeRestriction: false,
            TimeEnd0:new Date(2000, 0, 1, 0, 0, 0),
            TimeEnd1:new Date(2000, 0, 1, 0, 0, 0),
            TimeStart0:new Date(2000, 0, 1, 0, 0, 0),
            TimeStart1:new Date(2000, 0, 1, 0, 0, 0),
            Type: actionZoneTypes.NoSpeedRestriction,
            IsBeepInActionZone: false,
            IsAlertOnEnter: false,
            IsShowOnVDU: false,
            Label: "Action zone",
            Hole: 0,
            Course: 0,
            IsCartPathOnly: false,
            IsGeofence: false,
            ActivationDirection: -1,
            ImageFilename: "",
            ImageId: null,
        };
    }

    const addActionZones = () => {
        if (mapsData) {
            var boundsOfAZ = new mapsData.LatLngBounds();

            var bounds = {
                numberOfPositions: 0,
                bounds: boundsOfAZ
            }

            setBoundsOfActionZones(boundsOfAZ);
            setBoundsOfActionZonesInfo(bounds);
        }

        //Need to clone the object otherwise you can't modify the original one since is read only
        var clonedActionZonesPath = deepClone(actionZonesPath);

        for (var i = 0; i < clonedActionZonesPath.length; i++) {
            // add the AZ polygons
            if (clonedActionZonesPath[i].AzVertexes) {
                addPolygon(clonedActionZonesPath[i]);
            }
        }

        setActionZonesPolygons(actionZonesPolygons);

        // clear the AZ modified flag
        actionZoneModified.set(false);
    }

    const addPolygon = (actionZone) => {
        var paths = [];
        var inPath = [];
        var outPath = [];

        inPath = createInVertices(actionZone);

        if (inPath.length > 0) {
            var color = getActionZoneColor(actionZone.typeId);

            // if necessary, create the vertices for the outer Geofence path
            if (actionZone.IsGeofence) {
                outPath = createOutGeofenceVertices(inPath);
            }

            if (inPath.length && outPath.length)
                paths = [outPath, inPath];
            else {
                paths = inPath;
            }

            var polygon = new mapsData.Polygon({
                paths: paths,
                strokeColor: color,
                strokeOpacity: 0.9,
                strokeWeight: 2,
                fillColor: color,
                fillOpacity: 0.45,
                clickable: true, // set this to true if wiring click event on the polygon
                editable: false,
                zIndex: NORMAL_POLYGON_Z_INDEX
            });

            // add an extra property to the polygon so we can retrieve the details when the polygon is clicked
            polygon.actionZoneInfo = getActionZoneInfo(actionZone);
            polygon.actionZoneBuffer = addPolyline(actionZone);
            setPolygonListeners(polygon);
            polygon.setMap(null);
            actionZonesPolygons.push(polygon);
        }
    }

    const addPolyline = (actionZone) => {
        var inPath = [];
        var bufPath = [];

        inPath = createInVertices(actionZone);

        if (inPath.length > 0) {
            var color = getActionZoneColor(actionZone.typeId);
            var strokeWidth = actionZoneBufferWidth[mapData.getZoom() - 1];

            // create the vertices for the buffer
            bufPath = createBufGeofenceVertices(inPath);

            // Regular polyline options
            var polylineOptions = {
                path: bufPath,
                strokeColor: color,
                strokeOpacity: 0.3,
                strokeWeight: strokeWidth,
                clickable: false,
                editable: false
            };

            // optional modification of polyline options for action zones w/ form specified
            if (actionZone.Message && actionZone.Message.substring(0, 5) == "FORM:") {
                polylineOptions = {
                    ...polylineOptions,
                    icons: [{ icon: mapSymbols.DIAMOND, repeat: "20px" }]
                }
            }

            var polyline = new mapsData.Polyline(polylineOptions);

            polyline.setMap(null);

            return polyline;
        }
        return null;
    }

    const setPolygonListeners = (polygon) => {
        if (polygon) {
            var paths = polygon.getPaths();
            var path = paths.getAt(paths.length - 1);

            mapsData.event.addListener(polygon, "rightclick", function (event) {
                clickToDrivefeature(event);
            });

            mapsData.event.addListener(mapData,
                "bounds_changed",
                () => {
                    const actionZonesTab = "Action Zones";
                    const siteSetUpTab = "Site Setup";
                    const historyTab = "History";
                    if ((mapSideNavTabState.get() === actionZonesTab || mapSideNavTabState.get() === siteSetUpTab || mapSideNavTabState.get() === historyTab) && mapData.getTilt() === 45) {
                        mapData.setTilt(0);
                    }
                });

            mapsData?.event.addListener(polygon, "rightclick", function (e) {
                // Check if click was on a vertex control point
                if (e.vertex === undefined) {
                    mapsData?.event.trigger(mapData, "rightclick", e); // propogate in case we're using ClickToDrive on map
                    return;
                }
                if (e.path !== null && e.vertex !== null) {
                    hideDeleteVertexElement();

                    var thePath = paths.getAt(e.path);
                    if (thePath.getLength() > 3) {
                        thePath.removeAt(e.vertex);
                    }
                }
            });

            if (!carNumberHover.get()) {
                mapsData?.event.addListener(polygon, "click", function (point) {
                    selectAZPolygon(polygon);

                    if (point.vertex !== undefined) {
                        var localVertexToDeletePath = paths.getAt(point.path);
                        setVertexToDeletePath(localVertexToDeletePath);

                        if (localVertexToDeletePath.getLength() > 3) {
                            setVertexToDeleteIndex(point.vertex);

                            createDeleteVertexElement().open(mapData, polygon.getPaths().getAt(point.path), point.vertex, polygon);
                        }
                    } else {
                        hideDeleteVertexElement();
                    }
                });

                mapsData?.event.addListener(polygon, "mouseup", function (e) {
                    // Check if click was on a vertex control point
                    if (e.vertex === undefined) {
                        return;
                    }
                    if (e.path !== null && e.vertex !== null) {
                        hideDeleteVertexElement();
                        // Unfortunately the e.latLng position that is passed in here is for the position prior to when the vertex was
                        // actually moved.  So we will need to process this in the "set_at" event handler for the path
                    }
                });

                mapsData?.event.addListener(polygon, "mousemove", function (point) {
                    isMouseOverPolygon.set(true);
                    isMouseOverEdgeOrVertex.set(!isNaN(point.edge) || !isNaN(point.vertex));
                    selectEditAzPolygonCursor(false);
                    mouseOverAZPolygon(point.latLng);
                });

                mapsData?.event.addListener(polygon, "mouseout", function () {
                    mouseOutAZPolygon(polygon);
                    isMouseOverEdgeOrVertex.set(false);
                    isMouseOverPolygon.set(false);
                    selectEditAzPolygonCursor(false);
                });

                if (path) {
                    mapsData?.event.addListener(path, "set_at", function (vertex) {
                        actionZoneModified.set(true);

                        setPolygonActionZoneBufferPath(polygon);
                        // Check to see if e.latLng is within 1.5 meters of vertex immediately before or after the moved vertex.
                        // If so treat this as the user intention is to remove the current vertex by having it absorbed by the moved to vertex
                        // Note that vertex numbering starts with 0, i.e. it is zero based so we have to account for that below
                        if (path.getLength() > 3) {
                            // adjust tolerance for zoom level so user can still merge adjacent vertices when zoomed
                            // out furter and it still is easy to do and feels right.
                            var adjustedTolerance = Math.pow(2, maximumMapZoomLevel - mapData.getZoom()) * 0.00125;
                            var beforeVertex = vertex > 0 ? vertex - 1 : path.getLength() - 1;
                            var afterVertex = vertex === path.getLength() - 1 ? 0 : vertex + 1;
                            if (distanceCalc.distanceBetweenPoints(path.getAt(vertex), path.getAt(beforeVertex)) < adjustedTolerance ||
                                distanceCalc.distanceBetweenPoints(path.getAt(vertex), path.getAt(afterVertex)) < adjustedTolerance) {
                                // Note the timeout is required or we get an exception in Google Maps
                                setTimeout(function () {
                                    path.removeAt(vertex);
                                }, 100);
                            } else {
                                setPolygonActionZoneBufferPath(polygon);
                            }
                        } else {
                            setPolygonActionZoneBufferPath(polygon);
                        }
                    });

                    mapsData?.event.addListener(path, "insert_at", function () {
                        actionZoneModified.set(true);
                        setPolygonActionZoneBufferPath(polygon);
                    });

                    mapsData?.event.addListener(path, "remove_at", function () {
                        actionZoneModified.set(true);
                        setPolygonActionZoneBufferPath(polygon);
                    });
                }
            }

            if (mapSideNavTabState.get() === "CPO") {
                hideSubNav.set(true);
                subNavDataState.set("Map");
            }
        }
    }

    const setPolygonActionZoneBufferPath = (polygon) => {
        // update the buffer path for this polygon
        if (polygon && polygon.actionZoneBuffer) {
            var bufPath = [];
            var paths = polygon.getPaths();
            var path = paths.getAt(paths.length - 1);
            if (path) {
                for (var v = 0; v < path.length; v++) {
                    if (mapsData) {
                        bufPath.push(
                            new mapsData.LatLng(
                                path.getAt(v).lat(),
                                path.getAt(v).lng()
                            )
                        );
                    }
                }
                // Re-add the first vertex to close the polyline
                if (mapsData) {
                    bufPath.push(new mapsData.LatLng(path.getAt(0).lat(), path.getAt(0).lng()));
                }
                polygon.actionZoneBuffer.setPath(bufPath);
            }
        }
    }

    const mouseOutAZPolygon = (polygon) => {
        if (polygon) {
            // reset the polygon appearance and lower the zIndex
            polygon.setOptions({
                fillOpacity: 0.45,
                zIndex: NORMAL_POLYGON_Z_INDEX
            });
        }
    }

    const mouseOverAZPolygon = (latLng) => {
        var polygons = [];
        var poly = null;

        // get all of the AZ polygons for this point
        polygons = getAZPolygons(latLng);

        // find the smallest of those polygons
        if (polygons.length === 1) {
            poly = polygons[0];
        } else if (polygons.length > 0) {
            var smallestPoly = polygons[0];
            var smallestArea = mapsData.geometry.spherical.computeArea(
                smallestPoly.getPath()
            );
            for (var x = 1; x < polygons.length; x++) {
                var area = mapsData.geometry.spherical.computeArea(
                    polygons[x].getPath()
                );
                if (area < smallestArea) {
                    smallestArea = area;
                    smallestPoly = polygons[x];
                }
            }
            poly = smallestPoly;
        }

        // highlight the polygon, and increase the zIndex
        if (poly) {
            poly.setOptions({
                fillOpacity: 0.65,
                zIndex: SELECTED_POLYGON_Z_INDEX,
            });
        }
    }

    const getAZPolygons = (latLng) => {
        var polys = [];
        // find all polygons that contain the point latLng
        for (var x = 0; x < actionZonesPolygons.length; x++) {
            if (
                mapsData.geometry.poly.containsLocation(
                    latLng,
                    actionZonesPolygons[x]
                )
            ) {
                // set all of the polygons to a normal appearance and zIndex
                actionZonesPolygons[x].setOptions({
                    fillOpacity: 0.45,
                    zIndex: NORMAL_POLYGON_Z_INDEX,
                });
                polys.push(actionZonesPolygons[x]);
            }
        }
        return polys;
    }

    const selectAZPolygon = (polygon) => {
        if (polygon?.actionZoneInfo) {
            // if a new AZ polygon has been found
            if (mapSideNavTabState.get() === "Action Zones" && actionZoneId?.get() !== polygon?.actionZoneInfo?.Id) {
                if (checkActionZoneModified()) {
                    //currentAzClickedOnEditId is for when user clicks from one az to another so we actionZoneId becomes the previous az and currentAzClickedOnEditId becomes the newest one clicked
                    currentAzClickedOnEditId.set(polygon?.actionZoneInfo?.Id);
                    setDiscardModalOnLeave(onAzDiscardChanges);
                } else {
                    actionZoneSelected(polygon);
                }
            } else if (mapSideNavTabState.get() == "CPO") {
                actionZoneSelected(polygon);
            }
        }
    }

    const onAzDiscardChanges = () => {
        //currentAzClickedOnEditId is for when user clicks from one az to another so we actionZoneId becomes the previous az and currentAzClickedOnEditId becomes the newest one clicked
        let polygon = getSettablePolygon(currentAzClickedOnEditId.get());
        actionZoneSelected(polygon);
        setAlertModalIsOpen(false);
    }

    const onTabChangeAzDiscardChanges = () => {
        cancelActionZoneEditHelper();

        setAlertModalIsOpen(false);

        if (nextMainTabIndex.get()) {
            navigate(`/${nextMainTabName.get().toLowerCase()}`);
            nextMainTabIndex.set("");
        } else {
            subNavDataState.set("");
        }

        localStorage.setItem("activeMapSideNavTab", currentClickedTab.get());
        localStorage.setItem("mapSideNavTabState", currentClickedTab.get());
        mapSideNavTabState.set(currentClickedTab.get());
    }

    const checkActionZoneModified = () => {
        if (addActionZonePolygon.get() || cpoData.get()?.length || actionZoneModified.get() || checkVertices()) {
            return true;
        }

        return false;
    }

    const checkVertices = () => {
        if (Object.keys(editActionZonePolygonData).length > 0 && Object.keys(editActionZonePolygonVertices).length > 0) {
            var verts = getPolygonVertices(editActionZonePolygonData.get());

            if (verts.length) {
                if (verts.length !== editActionZonePolygonVertices.get().length)
                    return true;
                else {
                    for (var i = 0; i < verts.length; i++) {
                        if (verts[i].lat() !== editActionZonePolygonVertices.get()[i].lat() || verts[i].lng() !== editActionZonePolygonVertices.get()[i].lng()) {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }

    const getPolygonVertices = (polygon) => {
        // need to return a new array; don't just return polygon.getPath() or polygon.getPath().getArray()
        var arr = [];

        if (polygon) {
            var paths = polygon?.getPaths?.();
            var path = paths?.getAt(paths.length - 1);
            if (path) {
                for (var x = 0; x < path.length; x++) {
                    if (mapsData) {
                        arr.push(new mapsData.LatLng(path.getAt(x).lat(), path.getAt(x).lng()));
                    }
                }
                if (polygon.actionZoneInfo && polygon.actionZoneInfo.IsGeofence && courseExtents.get()) {
                    // for backwards compatibilty, add the course extents
                    // at the beginning of the Geofence vertices array
                    for (x = 0; x < courseExtents.get().length; x++) {
                        arr.splice(x, 0, courseExtents.get()[x]);
                    }
                }
            }
        }
        return arr;
    }

    const actionZoneSelected = (polygon, isSelectingNewlyCreatedActionZone) => {
        var i = 0;
        if (mapSideNavTabState.get() === "Action Zones") {
            // in case user clicked from one AZ to another without saving or canceling (acts as cancel)
            cancelActionZoneEditHelper();

            // Get the currentActionZone data
            //Logic for getCurrentActionZoneInfo is dealt on useEffect on index page located on sideNav/subSectionNav/Map/ActionZone/ActionZonesSubNav/index 
            actionZoneId.set(polygon?.actionZoneInfo?.Id);
            getCurrentActionZonePolygon(polygon);

            // Set the map
            if (drawingManager) {
                drawingManager.setMap(mapData);
            }

            openActionZoneWindow.set(true)

            if (isSelectingNewlyCreatedActionZone) {
                // A newly created Action Zone that is selected does not have any listeners associated with it so we need to add them here
                mapsData.event.addListener(
                    polygon,
                    "mousemove",
                    function (point) {
                        isMouseOverPolygon.set(true);
                        isMouseOverEdgeOrVertex.set(!isNaN(point.edge) || !isNaN(point.vertex));
                        selectEditAzPolygonCursor(false);
                    }
                );

                mapsData.event.addListener(
                    polygon,
                    "mouseout",
                    function () {
                        isMouseOverPolygon.set(false);
                        selectEditAzPolygonCursor(false);
                    }
                );
            }
        } else if (mapSideNavTabState.get() === "CPO") {
            //This is handle on useEffect on CarPath.jsx
            shouldCallCpoSelected.set((prev) => !prev);
            polygonSelectedForCpo.set(polygon);
        } else {
            setAlertModalTitle(t("Message"));
            setAlertModalContent("Action Zone Editing error");
            setAlertModalIsOpen(true);
            setAlertModalValidation(true);

            if (polygon?.actionZoneInfo) {
                // an error has occured, remove this AZ polygon from the map
                deleteActionZonePoly(getActionZonePolygonArrayIndexById(polygon?.actionZoneInfo?.Id));
            }
        }
    }

    const selectEditAzPolygonCursor = (clearCurrentCursorStyle) => {
        let localEditAzCssCursorToUse = editAzCssCursorToUse.get();
        let localEditAzCssCursorLastUsed = editAzCssCursorLastUsed.get();

        // We only have special cursors for the three most zoomed in levels of Google Maps API (18,19, and 20)
        // And, we only show the special cursors if we are over a polygon or we are drawing a new polygon
        if ((isMouseOverPolygon.get() || isDrawingNewPolygon.get()) && mapData?.getZoom() > 17) {
            // Select Cursor to use based on whether we are over an edge or vertext control point or not
            if (isDrawingNewPolygon.get() || isMouseOverEdgeOrVertex.get()) {
                localEditAzCssCursorToUse = azCreateCursorCssClass[mapData?.getZoom() - 1] ? azCreateCursorCssClass[mapData?.getZoom() - 1] : azCreateCursorCssClass[azCreateCursorCssClass.length];
            } else {
                localEditAzCssCursorToUse = azEditingCursorCssClass[mapData?.getZoom() - 1] ? azEditingCursorCssClass[mapData?.getZoom() - 1] : azEditingCursorCssClass[azEditingCursorCssClass.length];
            }

            // If the new cursor to use is different than the prior cursor, then clear out the prior cursor
            if (localEditAzCssCursorLastUsed && (localEditAzCssCursorLastUsed !== localEditAzCssCursorToUse || clearCurrentCursorStyle)) {
                if (mapData?.getDiv()?.className?.includes(localEditAzCssCursorLastUsed)) {
                    mapData.getDiv().className = mapData.getDiv().className.replace(localEditAzCssCursorLastUsed, "");
                }
            }
            // Apply the new cursor style and save away as last used
            mapData.getDiv().className = localEditAzCssCursorToUse;
            localEditAzCssCursorLastUsed = localEditAzCssCursorToUse;
        } else {
            // We are not over the polygon anymore or we zoomed out to google maps level 17 or less,
            // so revert to default cursor
            if (mapData?.getDiv()?.className?.includes(localEditAzCssCursorToUse)) {
                mapData.getDiv().className = mapData.getDiv().className.replace(localEditAzCssCursorToUse, "");
            }

            localEditAzCssCursorLastUsed = null;
        }

        if (localEditAzCssCursorToUse !== editAzCssCursorToUse.get()) {
            editAzCssCursorToUse.set(localEditAzCssCursorToUse);
        }

        if (localEditAzCssCursorLastUsed !== editAzCssCursorLastUsed.get()) {
            editAzCssCursorLastUsed.set(localEditAzCssCursorLastUsed);
        }
    }

    const cancelActionZoneEditHelper = () => {
        if (Object.keys(editActionZonePolygonData).length > 0) {
            let localActionZoneId = actionZoneId?.get()
            var pIndex = getActionZonePolygonArrayIndexById(localActionZoneId);
            var zIndex = getActionZoneArrayIndexById(localActionZoneId);

            let polygon = getSettablePolygon(actionZoneId.get());

            if (polygon) {
                disablePolygonEditMode(polygon);

                polygon.setMap(null);

                if (polygon?.actionZoneInfo?.IsNew) {
                    deleteActionZonePoly(getActionZonePolygonArrayIndexForNew());
                }
            }

            if (checkVertices()) {
                if (pIndex !== -1 && zIndex !== -1) {
                    deleteActionZonePoly(pIndex);
                    addPolygon(actionZonesPath[zIndex]);

                    setActionZonesPolygons(actionZonesPolygons);
                }
            }

            processActionZones();
            editActionZonePolygonData.set(null);
            toggleAddActionZonePolygon.set(null);
            addActionZonePolygon.set(null);
        }

        actionZoneId.set(0);
        actionZoneModified.set(false);
        lastSelectedActionZoneImageId.set(null);
    }

    const getSettablePolygon = (id) => {
        return actionZonesPolygons.find(x => x.actionZoneInfo.Id == id);
    }

    const getCurrentActionZonePolygon = (polygon) => {
        if (polygon) {
            let localActionZonePolygonVertices = editActionZonePolygonVertices.get();

            localActionZonePolygonVertices = getPolygonVertices(polygon);

            if (editActionZonePolygonData?.get()?.IsGeofence) {
                actionZoneVertexCount.set(localActionZonePolygonVertices.length - 2); // don't count the UL/LR points that prepend the list
            }
            else {
                actionZoneVertexCount.set(localActionZonePolygonVertices.length);
            }

            if (polygon) {
                actionZoneModified.set(polygon.actionZoneInfo.IsNew);
                polygon.setOptions({ editable: true });
            }

            editActionZonePolygonData.set(polygon);
            editActionZonePolygonVertices.set(localActionZonePolygonVertices);
        }
    }

    const getActionZonePolygonArrayIndexForNew = () => {
        // return -1 if not found (assumes there can only be one in the IsNew state at a time)
        var index = -1;
        if (actionZonesPolygons) {
            for (var az = 0; az < actionZonesPolygons.length; az++) {
                if (actionZonesPolygons[az].actionZoneInfo.IsNew) {
                    index = az;
                    break;
                }
            }
        }
        return index;
    }

    const getActionZonePolygonArrayIndexById = (id) => {
        // return -1 if not found
        var index = -1;
        if (actionZonesPolygons) {
            for (var az = 0; az < actionZonesPolygons.length; az++) {
                if (actionZonesPolygons[az]?.actionZoneInfo?.Id === id) {
                    index = az;
                    break;
                }
            }
        }
        return index;
    }

    const getActionZoneArrayIndexById = (id) => {
        // return -1 if not found
        var index = -1;
        if (actionZonesPath) {
            for (var az = 0; az < actionZonesPath.length; az++) {
                if (actionZonesPath[az].Id === id) {
                    index = az;
                    break;
                }
            }
        }
        return index;
    }

    const disablePolygonEditMode = (polygon) => {
        if (polygon) {
            polygon.setOptions({
                editable: false,
                strokeWeight: 2,
                fillOpacity: 0.45,
            });
        }

        if (drawingManager) {
            drawingManager.setMap(null);
        }
    }

    const deleteActionZonePoly = (index) => {
        let localActionZonesPolygons = actionZonesPolygons;

        if (index !== -1 && localActionZonesPolygons?.length) {
            // remove this polygon from the map
            if (localActionZonesPolygons[index].actionZoneBuffer)
                localActionZonesPolygons[index].actionZoneBuffer.setMap(null);

            localActionZonesPolygons[index].setMap(null);
            localActionZonesPolygons.splice(index, 1);
            updateActionZoneBounds();

            setActionZonesPolygons(localActionZonesPolygons);
        }
    }

    const createInVertices = (actionZone) => {
        var inPath = [];
        var getCourseExtents = courseExtents.get();

        if (actionZone.IsGeofence) {
            // If the course extents are being used for the Geofence
            if (actionZone.AzVertexes.length === getCourseExtents.length) {
                // Add the missing AZ vertices
                actionZone.AzVertexes = createCourseExtentsVertices();
            }
            else {
                var ULLRprepended = true;
                // check to see if the first vertices are different from the course extents
                for (var v = 0; v < getCourseExtents.length; v++) {
                    if (!nearlyEqual(actionZone.AzVertexes[v].Latitude, getCourseExtents[v].lat()) || !nearlyEqual(actionZone.AzVertexes[v].Longitude, getCourseExtents[v].lng())) {
                        ULLRprepended = false;
                        break;
                    }
                }
                if (ULLRprepended) {
                    // remove the course extents, and use the remaining vertices for the polygon
                    actionZone.AzVertexes.splice(0, getCourseExtents.length);
                }
            }

            for (var v = 0; v < actionZone.AzVertexes.length - 1; v++) {
                // google closes the polygon without repeating the last point
                if (mapsData) {
                    inPath.push(new mapsData.LatLng(actionZone.AzVertexes[v].Latitude, actionZone.AzVertexes[v].Longitude));
                }
            }
        }
        else {
            if (actionZone.AzVertexes) {
                // set the AZ polygon path 
                for (v = 0; v < actionZone.AzVertexes.length - 1; v++) {
                    // google closes the polygon without repeating the last point
                    if (mapsData) {
                        inPath.push(new mapsData.LatLng(actionZone.AzVertexes[v].Latitude, actionZone.AzVertexes[v].Longitude));
                    }
                }
            }
            else if (addActionZonePolygon.get()) {
                // set the new AZ polygon path
                for (v = 0; v < editActionZonePolygonVertices.get().length; v++) {
                    if (mapsData) {
                        inPath.push(new mapsData.LatLng(editActionZonePolygonVertices.get()[v].lat(), editActionZonePolygonVertices.get()[v].lng()));
                    }
                }
            }
        }
        return inPath;
    }

    // JG 09 May 16: added this for use in comparison below which determines whether the UL/LR points are prepended
    // This was failing at times because the original code looked for precise match, and didn't account for slight variance
    // often seen with floating point numbers.
    const nearlyEqual = (v1, v2) => {
        return Math.abs(v1 - v2) < 0.000005;    // close enough to equal (JG 24/Oct/18: raised this a bit to accomodate slight errors when displaying Chinese sites with GCJ-02 projection)
    }

    const createCourseExtentsVertices = () => {
        var ceVerts = [];
        var cePath = createCourseExtentsPolygonPath();
        if (cePath.length) {
            for (var v = 0; v < cePath.length; v++) {
                ceVerts.push({
                    'Id': 0,
                    'Latitude': cePath[v].lat(),
                    'Longitude': cePath[v].lng()
                });
            }
            // close the polygon by repeating the first point in the array
            ceVerts.push({
                'Id': 0,
                'Latitude': cePath[0].lat(),
                'Longitude': cePath[0].lng()
            });
        }
        return ceVerts;
    }

    const createCourseExtentsPolygonPath = () => {
        var cePath = [];
        var getCourseExtents = courseExtents.get();

        if (getCourseExtents?.length) {
            // set the path based on the course extents
            cePath.push(getCourseExtents[0]);

            if (mapsData) {
                cePath.push(new mapsData.LatLng(getCourseExtents[0].lat(), getCourseExtents[1].lng()));
            }

            cePath.push(getCourseExtents[1]);

            if (mapsData) {
                cePath.push(new mapsData.LatLng(getCourseExtents[1].lat(), getCourseExtents[0].lng()));
            }
        }
        return cePath;
    }

    const createOutGeofenceVertices = (inPath) => {
        var outPath = [];
        if (inPath && inPath.length) {
            var out = 0.02; // this sets increase value for the outer polygon
            var bounds = new mapsData.LatLngBounds();

            // get the bounds of this polygon
            inPath.forEach(function (coord) {
                bounds.extend(coord);
            });

            // Calculate the outer vertices based on the polygon bounds + out value then push them into the outPath array in reverse order
            if (mapsData) {
                outPath.push(new mapsData.LatLng(bounds.getSouthWest().lat() - out, bounds.getSouthWest().lng() - out));
                outPath.push(new mapsData.LatLng(bounds.getSouthWest().lat() - out, bounds.getNorthEast().lng() + out));
                outPath.push(new mapsData.LatLng(bounds.getNorthEast().lat() + out, bounds.getNorthEast().lng() + out));
                outPath.push(new mapsData.LatLng(bounds.getNorthEast().lat() + out, bounds.getSouthWest().lng() - out));
            }
        }
        return outPath;
    }

    const getActionZoneInfo = (actionZone) => {
        return {
            'IsNew': false, // not a property of the Action Zone dto so delete it before posting/putting
            'Id': actionZone.Id,
            'Message': actionZone.Message,
            'IsEnabled': actionZone.IsEnabled,
            'IsEnforcedForMarshal': actionZone.IsEnforcedForMarshal,
            'IsEnforcedForHandicapped': actionZone.IsEnforcedForHandicapped,
            'IsEnforcedForBeverage': actionZone.IsEnforcedForBeverage,
            'IsEnforcedForMemberCars': actionZone.IsEnforcedForMemberCars,
            'EnforceTimeRestriction': actionZone.EnforceTimeRestriction,
            'TimeStart0':actionZone.TimeStart0,
            'TimeEnd0': actionZone.TimeEnd0,
            'TimeStart1':actionZone.TimeStart1,
            'TimeEnd1': actionZone.TimeEnd1,
            'IsEnforcedForGolf': actionZone.IsEnforcedForGolf,
            'Type': actionZone.Type,
            'IsBeepInActionZone': actionZone.IsBeepInActionZone,
            'IsAlertOnEnter': actionZone.IsAlertOnEnter,
            'IsShowOnVDU': actionZone.IsShowOnVDU,
            'Label': actionZone.Label,
            'Hole': actionZone.Hole,
            'Course': actionZone.Course,
            'IsCartPathOnly': actionZone.IsCartPathOnly,
            'IsGeofence': actionZone.IsGeofence,
            'ActivationDirection': actionZone.ActivationDirection,
            'ImageFilename': actionZone.ImageFilename,
            'ImageId': actionZone.ImageId
        };
    }

    //azPolygons parameters is OPTIONAL
    const processActionZones = (azPolygons) => {
        let localActionZonesPolygons = azPolygons ? azPolygons : actionZonesPolygons;

        // Show AZ polygons based on filter settings
        for (var i = 0; i < localActionZonesPolygons.length; i++) {
            // clear the current AZ from the map
            localActionZonesPolygons[i].setMap(null);
            localActionZonesPolygons[i].actionZoneBuffer.setMap(null);

            // get the correct AZ appearance settings
            var color = getActionZoneColor(localActionZonesPolygons[i].actionZoneInfo.Type, localActionZonesPolygons[i].actionZoneInfo.Message == sizzleReelAZText);
            var colorFill = color;
            var opacityFill = 0.45;
            var strokeWidth = actionZoneBufferWidth[mapData.getZoom() - 1];

            if (deactiveAllAction.get()) {
                color = 'white';
                colorFill = 'transparent';
            }
            else if (siteSettingsData?.Features?.indexOf(featureKey.resortEdition) >= 0 && weatherAlertGlobalState.get()) {
                color = 'white';                // on Resort sites AZs are disabled during weather alert
                colorFill = 'transparent';
            }
            else if (localActionZonesPolygons[i].actionZoneInfo.IsEnabled === false) {
                colorFill = 'LightGray';
            }
            else if (localActionZonesPolygons[i].actionZoneInfo.IsNew) {
                colorFill = newPolyFillColor;
            }

            localActionZonesPolygons[i].setOptions({
                strokeColor: color,
                fillColor: colorFill,
                fillOpacity: opacityFill
            });

            localActionZonesPolygons[i].actionZoneBuffer.setOptions({
                strokeColor: color,
                strokeWeight: strokeWidth
            });

            if (localActionZonesPolygons[i].actionZoneInfo.IsNew) {
                localActionZonesPolygons[i].setMap(mapData);
                localActionZonesPolygons[i].actionZoneBuffer.setMap(mapData);
            }

            //  if (mapSideNavTabState.get() === "Action Zones" && optionsShowSurveys()) {
            //      if (localActionZonesPolygons[i].actionZoneInfo.Message && localActionZonesPolygons[i].actionZoneInfo.Message.substring(0,5) == "FORM:") {
            //        localActionZonesPolygons[i].setMap(mapData);
            //        localActionZonesPolygons[i].actionZoneBuffer.setMap(mapData);
            //      }
            //  }

            if (mapSideNavTabState.get() === "Action Zones" && messageActionZone.get()) {
                if (localActionZonesPolygons[i].actionZoneInfo.Hole === 0 &&
                    localActionZonesPolygons[i].actionZoneInfo.Type === actionZoneTypes.NoSpeedRestriction &&
                    !localActionZonesPolygons[i].actionZoneInfo.IsGeofence) {
                    localActionZonesPolygons[i].setMap(mapData);
                    localActionZonesPolygons[i].actionZoneBuffer.setMap(mapData);
                }
            }

            if (mapSideNavTabState.get() === "Action Zones" && controlsActionZone.get()) {
                if (localActionZonesPolygons[i].actionZoneInfo.Hole === 0 &&
                    localActionZonesPolygons[i].actionZoneInfo.Type !== actionZoneTypes.NoSpeedRestriction &&
                    !localActionZonesPolygons[i].actionZoneInfo.IsGeofence) {
                    localActionZonesPolygons[i].setMap(mapData);
                    localActionZonesPolygons[i].actionZoneBuffer.setMap(mapData);
                }
            }

            if ((mapSideNavTabState.get() === "Action Zones" && cartPathActionZone.get()) || mapSideNavTabState.get() == "CPO") {
                if (localActionZonesPolygons[i].actionZoneInfo.Hole > 0) {
                    localActionZonesPolygons[i].setMap(mapData);
                    localActionZonesPolygons[i].actionZoneBuffer.setMap(mapData);
                }
            }

            if (mapSideNavTabState.get() === "Action Zones" && geofenceActionZone.get()) {
                if (localActionZonesPolygons[i].actionZoneInfo.IsGeofence) {
                    localActionZonesPolygons[i].setMap(mapData);
                    localActionZonesPolygons[i].actionZoneBuffer.setMap(mapData);
                }
            }
        }

        updateActionZoneBounds();
        loadingOnProcess.set(false);
    }

    const updateActionZoneBounds = () => {
        // Recalculate the bounds for all visible Action Zone Polygons
        var getCourseExtents = courseExtents.get();

        if (mapsData) {
            var boundsOfAZ = new mapsData.LatLngBounds();

            var bounds = {
                numberOfPositions: 0,
                bounds: boundsOfAZ
            }

            actionZonesPolygons.forEach((polygon) => {
                if (polygon.getMap()) {
                    if (polygon.actionZoneInfo.IsGeofence) {
                        if (getCourseExtents?.length) {
                            // extend the bounds to the course extents
                            boundsOfAZ.extend(getCourseExtents[0]);
                            boundsOfAZ.extend(getCourseExtents[1]);
                            bounds.numberOfPositions = getCourseExtents.length;
                        }
                    }
                    else {
                        var latLngs = polygon.getPath();

                        if (latLngs) {
                            latLngs.forEach(function (latLng) {
                                boundsOfAZ.extend(latLng);
                                bounds.numberOfPositions++;
                            });
                        }
                    }

                    setBoundsOfActionZones(boundsOfAZ);
                    setBoundsOfActionZonesInfo(bounds);
                }
            });
        }
    }

    const heightMapOverlay = (bounds, image) => {
        let heightMap = null;

        if (mapsData) {
            heightMap = class Overlay extends mapsData.OverlayView {
                bounds;
                image;
                div;
                constructor(bounds, image) {
                    super();
                    this.bounds = bounds;
                    this.image = image;
                }
                /**
                 * onAdd is called when the map's panes are ready and the overlay has been
                 * added to the map.
                 */
                onAdd() {
                    this.div = document.createElement("div");
                    this.div.id = `heightMapImageDiv${siteId.get()}`;
                    this.div.style.borderStyle = "none";
                    this.div.style.borderWidth = "0px";
                    this.div.style.position = "absolute";
                    this.div.style.visibility = "hidden";

                    // Create the img element and attach it to the div.
                    const img = document.createElement("img");
                    img.id = "heightMapImage";
                    img.src = this.image;
                    img.style.width = "100%";
                    img.style.height = "100%";
                    img.style.position = "absolute";
                    img.style.opacity = "68%"
                    this.div.appendChild(img);

                    const opacitySlider = opacitySliderRef.current;
                    opacitySlider.min = "0";
                    opacitySlider.max = "100";
                    opacitySlider.value = "68";
                    opacitySlider.style.appearance = 'none';
                    opacitySlider.style.backgroundColor = 'white';
                    opacitySlider.style.visibility = "hidden";

                    opacitySlider.addEventListener("input", () => {
                        const opacityValue = opacitySlider.value / 100;
                        img.style.opacity = opacityValue;
                    });

                    if (opacityContainerRef) {
                        opacityContainerRef.current.appendChild(opacitySlider);
                    }

                    // Add the element to the "overlayLayer" pane.
                    const panes = this.getPanes();

                    panes.overlayLayer.appendChild(this.div);
                }
                draw() {
                    // We use the south-west and north-east
                    // coordinates of the overlay to peg it to the correct position and size.
                    // To do this, we need to retrieve the projection from the overlay.
                    const overlayProjection = this.getProjection();
                    // Retrieve the south-west and north-east coordinates of this overlay
                    // in LatLngs and convert them to pixel coordinates.
                    // We'll use these coordinates to resize the div.
                    const sw = overlayProjection.fromLatLngToDivPixel(
                        this.bounds.getSouthWest(),
                    );
                    const ne = overlayProjection.fromLatLngToDivPixel(
                        this.bounds.getNorthEast(),
                    );

                    // Resize the image's div to fit the indicated dimensions.
                    if (this.div) {
                        this.div.style.left = sw.x + "px";
                        this.div.style.top = ne.y + "px";
                        this.div.style.width = ne.x - sw.x + "px";
                        this.div.style.height = sw.y - ne.y + "px";
                    }
                }
                hide() {
                    const getHeightMapDiv = document.getElementById(`heightMapImageDiv${siteId.get()}`);
                    if (getHeightMapDiv) {
                        getHeightMapDiv.style.visibility = "hidden";
                    }

                    const opacitySlider = opacitySliderRef.current;
                    if (opacitySlider) {
                        opacitySlider.style.visibility = "hidden";
                    }

                    setIsHeightMapShowing(false);
                }
                show() {
                    const getHeightMapDiv = document.getElementById(`heightMapImageDiv${siteId.get()}`);
                    if (getHeightMapDiv) {
                        getHeightMapDiv.style.visibility = "visible";
                    }

                    const opacitySlider = opacitySliderRef.current;
                    if (opacitySlider) {
                        opacitySlider.style.visibility = "visible";
                    }

                    setIsHeightMapShowing(true);
                }
                toggle() {
                    const getHeightMapDiv = document.getElementById(`heightMapImageDiv${siteId.get()}`);
                    if (getHeightMapDiv) {
                        if (getHeightMapDiv.style.visibility === "hidden") {
                            this.show();
                        } else {
                            this.hide();
                        }
                    }
                }
            }
        }

        let overlay = new heightMap(bounds, image);
        overlay.setMap(mapData)
        return overlay;
    }

    const handleHeightMapValues = (event) => {
        let clickedLocation = event.latLng;
        const lat = clickedLocation.lat();
        const lng = clickedLocation.lng();

        const mapImageXYPointsRequest = {
            SiteId: parseInt(siteId.get()),
            Latitude: lat,
            Longitude: lng,
            XScale: mapImageData.XScale,
            XRotate: mapImageData.XRotate,
            XOffset: mapImageData.XOffset,
            YScale: mapImageData.YScale,
            YRotate: mapImageData.YRotate,
            YOffset: mapImageData.YOffset
        };

        const elevationService = new mapsData.ElevationService();

        elevationService.getElevationForLocations(
            {
                locations: [{ lat, lng }],
            },
            (results, status) => {
                if (status === "OK" && results[0]) {
                    if (mapImageData.XScale) {
                        dispatch(COMMON_SERVICES.getXYPointsInImageServices(mapImageXYPointsRequest));
                    }

                    const infoArray = [
                        `Latitude: ${lat}`,
                        `Longitude: ${lng}`,
                        `X Pixel: N/A`,
                        `Y Pixel: N/A`,
                        `Grey scale: N/A`,
                        `Min Elevation: ${mapImageData.MinElevation}`,
                        `Max Elevation: ${mapImageData.MaxElevation}`,
                        `Elevation: N/A`,
                        `Google Maps Api Elevation: ${results[0].elevation.toFixed(2)} meters`,
                        `NW: ${mapImageData.NwLat}, ${mapImageData.NwLng}`,
                        `NE: ${mapImageData.NeLat}, ${mapImageData.NeLng}`,
                        `SW: ${mapImageData.SwLat}, ${mapImageData.SwLng}`,
                        `SE: ${mapImageData.SeLat}, ${mapImageData.SeLng}`,
                        `Image Width: ${mapImageData.ImageWidth}`,
                        `Image Height: ${mapImageData.ImageHeight}`
                    ];

                    setHeightMapInfo(infoArray);
                }
            }
        );
    }

    const mapToElevation = (blueValue, minElevation, elevationRange) => {
        const normalizedValue = blueValue / 255; // Normalize the pixel value
        const mappedValue = elevationRange * normalizedValue; // Scale to elevation range
        return minElevation + mappedValue; // Add min elevation
    }

    const hideDeleteVertexElement = () => {
        setVertexToDeleteIndex(-1);
        setVertexToDeletePath(null);
        createDeleteVertexElement()?.close();
    }

    const stopActionZonePanel = () => {
        cancelActionZoneEditHelper();
        openActionZoneWindow.set(false);
        hideDeleteVertexElement();
    }

    const closeActionZoneEdits = () => {
        stopActionZonePanel();
        addActionZonePolygon.set(false);
    }

    const closeActionZoneEditsOnMessage = () => {
        closeActionZoneEdits();
        messageActionZone.set((prevState) => !prevState);
        localStorage.setItem("messageActionZone", messageActionZone.get());
    }

    const closeActionZoneEditsOnControl = () => {
        closeActionZoneEdits();
        controlsActionZone.set((prevState) => !prevState);
        localStorage.setItem("controlsActionZone", controlsActionZone.get());
    }

    const closeActionZoneEditsOnCarPathOnly = () => {
        closeActionZoneEdits();
        cartPathActionZone.set((prevState) => !prevState);
        localStorage.setItem("cartPathActionZone", cartPathActionZone.get());
    }

    const closeActionZoneEditsOnGeofence = () => {
        closeActionZoneEdits();
        geofenceActionZone.set((prevState) => !prevState);
        localStorage.setItem("geofenceActionZone", geofenceActionZone.get());
    }

    const setNewActionZonePoly = () => {
        if (addActionZonePolygon.get()) {
            drawingManager.setMap(mapData);
            drawingManager.setDrawingMode(mapsData.drawing.OverlayType.POLYGON);
            // Setup variables such that we select the correct cursor
            isDrawingNewPolygon.set(true);
        } else {
            drawingManager.setDrawingMode(null);
            // Setup variables such that we select the correct cursor
            isDrawingNewPolygon.set(false);
        }

        selectEditAzPolygonCursor();
    }

    const handleCancelEditActionZone = () => {
        stopActionZonePanel();
        setAlertModalIsOpen(false);
    }

    //#endregion Action Zones Functions

    const callPolygonForSiteSetup = () => {
        displayHideAreaPolygon(
            extsBtn.get(),
            extsAreaPathState,
            extsPathCoordsState,
            extsZoneDisplayed,
            setExtsZoneDisplayed,
            "#0202f2",
            1,
            mapData,
            mapsData,
            addListenersOnEditSiteAreaChangesPolygon,
            addListenersOnEditSiteAreaFinalPolygon,
            addListenersOnEditAreaFinalPolygon,
            polygonClick,
            polyMouseOver,
            polyMouseOut,
            showAreas.get()
        );
        displayHideAreaPolygon(
            teesBtn.get(),
            teesAreaPathState,
            teesPathCoordsState,
            teesZoneDisplayed,
            setTeesZoneDisplayed,
            "#eb0c0a",
            2,
            mapData,
            mapsData,
            addListenersOnEditSiteAreaChangesPolygon,
            addListenersOnEditSiteAreaFinalPolygon,
            addListenersOnEditAreaFinalPolygon,
            polygonClick,
            polyMouseOver,
            polyMouseOut,
            showAreas.get()
        );
        displayHideAreaPolygon(
            gmsBtn.get(),
            gmsAreaPathState,
            gmsPathCoordsState,
            gmsZoneDisplayed,
            setGmsZoneDisplayed,
            "#067c05",
            3,
            mapData,
            mapsData,
            addListenersOnEditSiteAreaChangesPolygon,
            addListenersOnEditSiteAreaFinalPolygon,
            addListenersOnEditAreaFinalPolygon,
            polygonClick,
            polyMouseOver,
            polyMouseOut,
            showAreas.get()
        );
        displayHideAreaPolygon(
            fwysBtn.get(),
            fwysAreaPathState,
            fwysPathCoordsState,
            fwysZoneDisplayed,
            setFwysZoneDisplayed,
            "#f0f004",
            4,
            mapData,
            mapsData,
            addListenersOnEditSiteAreaChangesPolygon,
            addListenersOnEditSiteAreaFinalPolygon,
            addListenersOnEditAreaFinalPolygon,
            polygonClick,
            polyMouseOver,
            polyMouseOut,
            showAreas.get()
        );
        if (!hideAll.get()) {
            displayHideAreaPolygon(
                stgsBtn.get(),
                stgsAreaPathState,
                stgsPathCoordsState,
                stgsZoneDisplayed,
                setStgsZoneDisplayed,
                "#663a83",
                5,
                mapData,
                mapsData,
                addListenersOnEditSiteAreaChangesPolygon,
                addListenersOnEditSiteAreaFinalPolygon,
                addListenersOnEditAreaFinalPolygon,
                polygonClick,
                polyMouseOver,
                polyMouseOut,
                showAreas.get()
            );
        }
    };

    const showNewAreaPolygon = () => {
        drawAreaPolygon && drawAreaPolygon.setMap(mapData);
    };

    const handleEditCourseChange = (e) => {
        setCourseEditName(e?.target ? e.target.value : e);
        let data = siteSettingsData.Courses;
        let obj = data.find((o) => (o.Number === e?.target ? e.target.value : e));
        let holeNumber = obj.HoleCount;
        setHoleCount(holeNumber);
    };

    const teeEditHandleChange = (event) => {
        let index = teeMarkersDataState.findIndex(
            (item) => item.Id === Number(editId)
        );
        const updatedData = [...teeMarkersDataState];
        updatedData[index] = {
            ...updatedData[index],
            TeeMarkerSettingId: event.target.value,
        };
        setTeeEditValue(event.target.value);
        setTeeEditCopy(event.target.value);
    };

    const poiEditHandleChange = (e) => {
        let index = pointsOfInterestDataState.findIndex(
            (item) => item.Id === Number(editId)
        );
        const updatedData = [...pointsOfInterestDataState];
        updatedData[index] = {
            ...updatedData[index],
            Type: e.target.value,
        };
        setPoiEditTypeValue(e.target.value);
        setPoiEditTypeCopy(e.target.value);
    };

    const poiEditPositionHandleChange = (e) => {
        let index = pointsOfInterestDataState.findIndex(
            (item) => item.Id === Number(editId)
        );
        const updatedData = [...pointsOfInterestDataState];
        updatedData[index] = {
            ...updatedData[index],
            LabelPosition: e.target.value,
        };
        setPoiEditPositionValue(e.target.value);
        setPoiEditPositionCopy(e.target.value);
    };

    const singleLocationLat = siteLocationsData?.filter(
        (item) => item.Id === Number(siteId.get())
    );

    let defaultProps = {
        center: {
            lat: checkCenterLat(
                showHoleMarker,
                singleSiteLocationData.get(),
                site,
                singleLocationLat,
                carData
            ),
            lng: checkCenterLng(
                showHoleMarker,
                singleSiteLocationData.get(),
                site,
                singleLocationLat,
                carData
            ),
        },
        zoom: checkZoom(
            siteLocationGlobalData.get(),
            singleSiteLocationData.get(),
            site
        ),
    };
    const [lat, setLat] = useState('');
    const [lng, setLng] = useState('');
    const [isValidLng, setIsValidLng] = useState("");
    const [isValidLat, setIsValidLat] = useState("");
    const [center, setCenter] = useState({});
    const [openSiteExtent, setOpenSiteExtent] = useState(false);
    var privilege = getVisagaUsersListAction && getVisagaUsersListAction.length > 0 && getVisagaUsersListAction?.filter((a) => a.username === getUserRole.Name);
    var canAccessSiteSetup = privilege && privilege.length > 0 && privilege[0].SiteSetup;
    const handleSetSiteExtentOpen = () => setOpenSiteExtent(true);
    const handleSaveExtentClose = () => setOpenSiteExtent(false);

    const handleSetSiteExtentClick = () => {
        const bounds = mapData?.getBounds();
        var ne = bounds.getNorthEast();
        var sw = bounds.getSouthWest();
        var ulLat = ne.lat();
        var ulLong = sw.lng();
        var lrLat = sw.lat();
        var lrLong = ne.lng();

        var fudgeX = (lrLong - ulLong) / 10.0;
        var fudgeY = (ulLat - lrLat) / 10.0;
        let payload = {
            SiteId: siteId.get(),
            ULlatitude: ulLat - fudgeY,
            ULlongitude: ulLong + fudgeX,
            LRlatitude: lrLat + fudgeY,
            LRlongitude: lrLong - fudgeX
        };
        dispatch(COMMON_SERVICES.setSiteExtentsServices(payload))
            .then(() => {
                setOpenSiteExtent(false);
                getCourseExtents(siteSettingsData, mapsData, courseExtents);
                dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
            });
    }
    const handleGoButtonClick = () => {
        const latitude = parseFloat(lat);
        const longitude = parseFloat(lng);

        if (!isNaN(latitude) && !isNaN(longitude)) {
            setIsValidLat("");
            setIsValidLng("");
            setGoClick(true);
            setCenter({ lat: latitude, lng: longitude });
        } else {
            isNaN(latitude) ? setIsValidLat(<p style={{ color: "red" }}>{t("Invalid_Latitude")}</p>) : setIsValidLat("");
            isNaN(longitude) ? setIsValidLng(<p style={{ color: "red" }}>{t("Invalid_Longitude")}</p>) : setIsValidLng("");
        }
    };
    const getMapOptions = (maps) => {
        return {
            zoomControl: true,
            fullscreenControl: true,
            disableDefaultUI: true,
            mapTypeControl: true,
            streetViewControl: false,
            panControl: false,
            zoomControlOptions: {
                position: maps.ControlPosition.RIGHT_BOTTOM,
                style: maps.ZoomControlStyle.SMALL,
            },
            draggableCursor: 'default',
            draggingCursor: 'move',
            mapTypeControlOptions: {
                position: maps.ControlPosition.RIGHT_BOTTOM,
            },
            fullscreenControlOptions: {
                position: maps.ControlPosition.RIGHT_BOTTOM,
            },
            gestureHandling: "greedy",
            styles: [
                {
                    featureType: "poi",
                    elementType: "labels",
                    stylers: [{ visibility: "off" }],
                },
            ],
            scrollwheel: true,

            MapTypeId: mapTypeHandler.get(),
            tilt: (
                mapSideNavTabState.get() === "Action Zones" ||
                mapSideNavTabState.get() === "Site Setup" ||
                mapSideNavTabState.get() === "History"
            ) ? 0 : mapData?.getTilt()
        };
    };

    // Click event for Hole Area
    function addListenersOnEditAreaFinalPolygon(data) {
        mapsData.event.addListener(data, "click", function (e) {
            if (carPopupClickEvent.get() !== null) {
                carPopupClickEvent.set(null);
                return;
            }
            if (areaModified.get()) {
                setIsHoleAreaPolygon(true);
                setSiteAreaClickEvent(e);
                setSiteAreaClickEventData(data);

                setDiscardModalOnLeave(discardChangesForSiteArea);
                return;
            } else {
                updateClickedHoleAreaPolygon(data, e);
            }
        });
        addListenersOnEditSiteAreaChangesPolygon(data);
    }

    function updateClickedHoleAreaPolygon(data, e) {
        let filterValue = siteSetupState?.length > 0 && siteSetupState[0]?.HoleAreas?.filter((item) => item.Id === data.indexID);

        setSiteSetupSaveActiveButton(false);
        setIsHoleAreaPolygon(false);
        setOpenSiteAreaWindow(false);
        setOpenAreaWindow(false);
        setIndexID(data.indexID);
        setTempSiteId(filterValue);
        setTempPolygon([...filterValue[0].Polygon]);

        if (!verticesCount)
            setVerticesCount(filterValue[0].Polygon.length);

        setCourseNameModel(filterValue[0].Course);
        courseNameHandleChange(filterValue[0].Course);
        setHoleNoModel(filterValue[0].Hole);
        setCourseTypeModel(filterValue[0].Type);
        courseTypeHandleChange(filterValue[0].Type);
        typeHole.set(filterValue[0].Type);

        if (editSiteSetup.get()) {
            let y = e.domEvent.y;
            let x = e.domEvent.x;
            if (y > window.innerHeight - 300) y = window.innerHeight - 300;
            if (x > window.innerWidth - 300) x = window.innerWidth - 360;
            let obj = {
                position: "fixed",
                top: 50 + y + "px",
                left: 110 + x + "px",
            };
            setSitesetupDialogBox(obj);
            setEditSelectedData((prevData) => {
                if (prevData?.indexID !== data.indexID) {
                    prevData?.setOptions({
                        editable: false,
                        fillOpacity: 0.2,
                    });
                }
            });
        }

        let siteIdGet = siteId.get();

        let imageData = {
            courseNumber: filterValue[0].Course,
            holeNumber: filterValue[0].Hole,
            siteIdGet,
        };
        imagePreview({}, imageData, {});
        if (editSiteSetup.get()) {
            setEditModel(false);
            if (filterValue.length) setOpenAreaWindow(true);
            data?.setOptions({
                editable: true,
                fillOpacity: 0.6,
            });
        }
        setEditSelectedData(data);
        previousEditedPolygon.set(data);
    }

    // Click event for Site Area
    function addListenersOnEditSiteAreaFinalPolygon(data) {
        mapsData.event.addListener(data, "click", function (e) {
            if (carPopupClickEvent.get()) {
                carPopupClickEvent.set(null);
                return;
            }
            if (areaModified.get()) {
                setIsSiteAreaPolygon(true);
                setSiteAreaClickEvent(e);
                setSiteAreaClickEventData(data);

                setDiscardModalOnLeave(discardChangesForSiteArea);
                return;
            } else {
                updateClickedSiteAreaPolygon(data, e);
            }
        });
        addListenersOnEditSiteAreaChangesPolygon(data);
    }

    function updateClickedSiteAreaPolygon(data, e) {
        setSiteAreaSaveActiveButton(false);
        setIsSiteAreaPolygon(false);

        if (editSiteSetup.get()) {
            let filterValue = siteSetupState?.length > 0 && siteSetupState[0]?.SiteAreas?.filter((item) => item.Id === data.indexID);

            let y = e.domEvent.y;
            let x = e.domEvent.x;
            if (y > window.innerHeight - 300) y = window.innerHeight - 300;
            if (x > window.innerWidth - 300) x = window.innerWidth - 360;
            let obj = {
                position: "fixed",
                top: 20 + y + "px",
                left: 40 + x + "px",
            };
            setSitesetupDialogBox(obj);
            setEditSelectedData((prevData) => {
                if (prevData?.indexID !== data.indexID) {
                    prevData?.setOptions({
                        editable: false,
                        fillOpacity: 0.2,
                    });
                }
            });

            setOpenAreaWindow(false);
            setIndexID(data.indexId);
            setTempSiteData(filterValue);
            setTempSiteId(filterValue);
            setTempPolygon(filterValue[0].Polygon);
            if (!verticesCount) setVerticesCount(filterValue[0].Polygon.length);
            setOpenSiteAreaWindow(true);
            data?.setOptions({
                editable: true,
                fillOpacity: 0.6,
            });
            setEditSelectedData(data);
        }
    }

    const polygonClick = (data) => {
        mapsData.event.addListener(data, "contextmenu", (e) => {
            if (enableClickToDriveFeature.get() && data) {
                clickToDrivefeature(e);
            }
        });
    };

    const polyMouseOver = (polygon) => {
        mapsData.event.addListener(polygon, "mouseover", () => {
            if (enableClickToDriveFeature.get() && polygon != null) {
                polygon.setOptions({ cursor: "alias" });
            }
            if (polygon != null) {
                polygon.setOptions({
                    fillOpacity: 0.6,
                });
            }
        });
    };

    const polyMouseOut = (polygon) => {
        mapsData.event.addListener(polygon, "mouseout", () => {
            if (polygon != null) {
                polygon.setOptions({
                    fillOpacity: 0.15,
                });
            }
        });
    };

    const getCordFromPoly = (poly) => {
        let CurrentArr = [];
        if (poly.getPath().length > 1) {
            let vertices = poly.getPaths().getArray()[0];
            vertices.forEach((vertex) => {
                const lat = vertex.lat();
                const lng = vertex.lng();
                CurrentArr.push({
                    // Id: 0,
                    Lat: lat,
                    Lon: lng,
                });
            });
        }

        return CurrentArr;
    };

    function addListenersOnEditSiteAreaChangesPolygon(data) {
        mapsData.event.addListener(data, "mousedown", function () {
            mapsData.event.addListener(data.getPath(), "set_at", function () {
                var path = data.getPath();
                var bounds = new mapsData.LatLngBounds();
                for (var i = 0; i < path.length; i++) {
                    bounds.extend(path.getAt(i));
                }

                let arr = [];
                for (let i = 0; i < path.getLength(); i++) {
                    const xy = path.getAt(i);
                    arr.push({
                        Lat: xy.lat(),
                        Lon: xy.lng(),
                    });
                }

                setTempSiteEdit(arr);
                setTempPolygon(arr);
                setVerticesCount(arr.length);
                setIsTempPolygon(true);
                setSiteAreaSaveActiveButton(true);

                let exPoly = siteSetupData?.HoleAreas.find((item) => item.Id === data.indexID);

                if (JSON.stringify(getCordFromPoly(data)) === JSON.stringify(exPoly?.Polygon)) {
                    setSiteSetupSaveActiveButton(false);
                    setIsTempPolygon(false);
                    areaModified.set(false);
                } else {
                    setSiteSetupSaveActiveButton(true);
                    setIsTempPolygon(true);
                    areaModified.set(true);
                }
            });

            mapsData.event.addListener(data.getPath(), "insert_at", function () {
                var path = data.getPath();
                var bounds = new mapsData.LatLngBounds();
                for (var i = 0; i < path.length; i++) {
                    bounds.extend(path.getAt(i));
                }

                let arr = [];
                for (let i = 0; i < path.getLength(); i++) {
                    const xy = path.getAt(i);
                    arr.push({
                        Lat: xy.lat(),
                        Lon: xy.lng(),
                    });
                }

                setTempSiteEdit(arr);
                setTempPolygon(arr);
                setVerticesCount(arr.length);
                setIsTempPolygon(true);
                setSiteSetupSaveActiveButton(true);
                setSiteAreaSaveActiveButton(true);

                areaModified.set(true);
            });

            mapsData.event.addListener(data.getPath(), "remove_at", function () {
                let exPoly = siteSetupData?.HoleAreas.find((item) => item.Id === data.indexID);

                if (JSON.stringify(getCordFromPoly(data)) === JSON.stringify(exPoly?.Polygon)) {
                    setSiteSetupSaveActiveButton(false);
                    setIsTempPolygon(false);
                    areaModified.set(false);
                } else {
                    setSiteSetupSaveActiveButton(true);
                    setIsTempPolygon(true);
                    areaModified.set(true);
                }
            });
        });
    }

    const handleGoogleMapApis = (map, maps) => {
        setMap(map);
        setMaps(maps);
        mapDataGlobalState.set(map);
        mapsDataGlobalState.set(maps);

        if (mapData != null && mapsData != null) {
            let taggedCars = JSON.parse(JSON.stringify(taggedCarsSaverGlobalState.get()));

            if (((findCars.get() && taggedCars.length > 0) || messageFindCar.get() || paceFindCar.get()) && !all) {
                const bounds = getMapBoundsForFindCars(
                    map,
                    maps,
                    taggedCarsSaverGlobalState.get(),
                    carData,
                    allCarData,
                    isValidLocation,
                    setNotAvailableCars,
                    findCars,
                    getMapBoundsForAllCars,
                    setOpenPopupNotAvailableCars,
                    setAll
                );
                map.fitBounds(bounds);
                findCars.set(false);
            }

            if (!findCars.get() && all) {
                if (carData.length > 0) {
                    const bounds = getMapBoundsForAllCars(
                        map,
                        maps,
                        carData,
                        isValidLocation,
                        setAll
                    );
                    map.fitBounds(bounds);
                } else {
                    setAll(false);
                    setSite(true);
                }
            }

            // ================================================ Course Rendering Start =============================================== //
            const marks = mapsData &&
                new mapsData.Marker({
                    position: newPosition,
                });

            // ================================================ Course Overlay Rendering End =============================================== //

            const finalData = siteSetupState;

            setFinalDataState(finalData);

            // Tees data filter start

            let teesAreaPath =
                finalData &&
                finalData.length > 0 &&
                finalData[0]?.HoleAreas?.filter((item) => item.Type === 0);

            setTeesAreaPathState(teesAreaPath);

            let teesData =
                teesAreaPath &&
                teesAreaPath.length > 0 &&
                teesAreaPath?.map((item) => {
                    return item.Polygon;
                });
            let updated_teesData = teesData && teesData.length > 0 && teesData;

            const teesPathCoords =
                mapsData &&
                    updated_teesData &&
                    updated_teesData !== undefined &&
                    updated_teesData.length !== 0
                    ? updated_teesData?.map((item4) => {
                        return item4?.map((innerItem) => {
                            return (mapsData.LatLngLiteral = {
                                lat: innerItem.Lat,
                                lng: innerItem.Lon,
                            });
                        });
                    })
                    : "";

            setTeesPathCoords(teesPathCoords);

            // stgs data filter start
            let siteAreaPath =
                finalData &&
                finalData.length > 0 &&
                finalData[0]?.SiteAreas?.filter((item) => item.Type === 0);

            setStgsAreaPathState(siteAreaPath);

            let siteData =
                siteAreaPath &&
                siteAreaPath.length > 0 &&
                siteAreaPath?.map((item) => {
                    return item.Polygon;
                });
            let updated_siteData = siteData && siteData.length > 0 && siteData;

            const sitePathCoords =
                mapsData &&
                    updated_siteData &&
                    updated_siteData !== undefined &&
                    updated_siteData.length !== 0
                    ? updated_siteData?.map((item4) => {
                        return item4?.map((innerItem) => {
                            return (mapsData.LatLngLiteral = {
                                lat: innerItem.Lat,
                                lng: innerItem.Lon,
                            });
                        });
                    })
                    : "";

            setStgsPathCoords(sitePathCoords);

            // fwys data filter start
            let fwysAreaPath =
                finalData &&
                finalData.length > 0 &&
                finalData[0]?.HoleAreas?.filter((item) => item.Type === 1);
            let fwysData =
                fwysAreaPath &&
                fwysAreaPath.length > 0 &&
                fwysAreaPath?.map((item) => {
                    return item.Polygon;
                });

            setFwysAreaPathState(fwysAreaPath);

            let updated_fwysData = fwysData && fwysData.length > 0 && fwysData;

            const fwysPathCoords =
                mapsData &&
                    updated_fwysData &&
                    updated_fwysData !== undefined &&
                    updated_fwysData.length !== 0
                    ? updated_fwysData?.map((item4) => {
                        return item4?.map((innerItem) => {
                            return (mapsData.LatLngLiteral = {
                                lat: innerItem.Lat,
                                lng: innerItem.Lon,
                            });
                        });
                    })
                    : "";

            setFwysPathCoords(fwysPathCoords);

            // grns data filter start
            let grnsAreaPath =
                finalData &&
                finalData.length > 0 &&
                finalData[0]?.HoleAreas?.filter((item) => item.Type === 2);
            let grnsData =
                grnsAreaPath &&
                grnsAreaPath.length > 0 &&
                grnsAreaPath?.map((item) => {
                    return item.Polygon;
                });

            setGmsAreaPathState(grnsAreaPath);

            let updated_grnsData = grnsData && grnsData.length > 0 && grnsData;

            const grnsPathCoords =
                mapsData &&
                    updated_grnsData &&
                    updated_grnsData !== undefined &&
                    updated_grnsData.length !== 0
                    ? updated_grnsData?.map((item4) => {
                        return item4?.map((innerItem) => {
                            return (mapsData.LatLngLiteral = {
                                lat: innerItem.Lat,
                                lng: innerItem.Lon,
                            });
                        });
                    })
                    : "";

            setGmsPathCoords(grnsPathCoords);

            // exts data filter start
            let extsAreaPath =
                finalData &&
                finalData.length > 0 &&
                finalData[0]?.HoleAreas?.filter((item) => item.Type === 3);
            let extsData =
                extsAreaPath &&
                extsAreaPath.length > 0 &&
                extsAreaPath?.map((item) => {
                    return item.Polygon;
                });

            setExtsAreaPathState(extsAreaPath);
            let updated_extsData = extsData && extsData.length > 0 && extsData;

            const extsPathCoords =
                mapsData &&
                    updated_extsData &&
                    updated_extsData !== undefined &&
                    updated_extsData.length !== 0
                    ? updated_extsData?.map((item4) => {
                        return item4?.map((innerItem) => {
                            return (mapsData.LatLngLiteral = {
                                lat: innerItem.Lat,
                                lng: innerItem.Lon,
                            });
                        });
                    })
                    : "";

            setExtsPathCoords(extsPathCoords);

            if (siteAreaPath !== undefined && showAreas.get() && stgsBtn.get() && !hideAll.get() && stgsZoneDisplayed.length === 0) {
                let temp = [];
                for (let i = 0; i < siteAreaPath.length; i++) {
                    var siteAreaDemo = new mapsData.Polygon({
                        paths: sitePathCoords[i],
                        strokeColor: "#663a83",
                        strokeOpacity: 0.9,
                        strokeWeight: 2,
                        fillColor: "#663a83",
                        fillOpacity: 0.15,
                        indexID: siteAreaPath[i].Id
                    });

                    siteAreaDemo?.setMap(map);
                    temp = [...temp, siteAreaDemo];
                    addListenersOnEditSiteAreaFinalPolygon(siteAreaDemo);
                    addListenersOnEditSiteAreaChangesPolygon(siteAreaDemo);
                    polygonClick(siteAreaDemo);
                    polyMouseOver(siteAreaDemo);
                    polyMouseOut(siteAreaDemo);
                }
                setStgsZoneDisplayed(temp);
            }

            if (extsAreaPath !== undefined && showAreas.get() && extsBtn.get() && !hideAll.get() && extsZoneDisplayed.length === 0) {
                let temp = [];
                for (let i = 0; i < extsAreaPath.length; i++) {
                    extsZoneState = new mapsData.Polygon({
                        paths: extsPathCoords[i],
                        strokeColor: "#0202f2",
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: "#0202f2",
                        fillOpacity: 0.15,
                        indexID: extsAreaPath[i].Id,
                        zIndex: 1,
                    });


                    extsZoneState?.setMap(map);
                    temp = [...temp, extsZoneState];
                    addListenersOnEditAreaFinalPolygon(extsZoneState, extsPathCoords);
                    polygonClick(extsZoneState);
                    polyMouseOver(extsZoneState);
                    polyMouseOut(extsZoneState);
                }
                setExtsZoneDisplayed(temp);
            }

            if (grnsAreaPath !== undefined && showAreas.get() && gmsBtn.get() && !hideAll.get() && gmsZoneDisplayed.length === 0) {
                let temp = [];

                for (let i = 0; i < grnsAreaPath.length; i++) {
                    gmsZoneState = new mapsData.Polygon({
                        paths: grnsPathCoords[i],
                        strokeColor: "#067c05",
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: "#067c05",
                        fillOpacity: 0.15,
                        indexID: grnsAreaPath[i].Id,
                        zIndex: 3,
                    });
                    gmsZoneState.setMap(map);
                    temp = [...temp, gmsZoneState];

                    addListenersOnEditAreaFinalPolygon(gmsZoneState, grnsPathCoords);
                    polygonClick(gmsZoneState);
                    polyMouseOver(gmsZoneState);
                    polyMouseOut(gmsZoneState);
                }
                setGmsZoneDisplayed(temp);
            }

            if (fwysAreaPath !== undefined && showAreas.get() && fwysBtn.get() && !hideAll.get() && fwysZoneDisplayed.length === 0) {
                let temp = [];
                for (let i = 0; i < fwysPathCoords.length; i++) {
                    fwysZoneState = new mapsData.Polygon({
                        paths: fwysPathCoords[i],
                        strokeColor: "#f0f004",
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: "#f0f004",
                        fillOpacity: 0.15,
                        indexID: fwysAreaPath[i].Id,
                        zIndex: 4,
                    });
                    fwysZoneState.setMap(map);
                    temp = [...temp, fwysZoneState];
                    addListenersOnEditAreaFinalPolygon(fwysZoneState, fwysPathCoords);
                    polygonClick(fwysZoneState);
                    polyMouseOver(fwysZoneState);
                    polyMouseOut(fwysZoneState);
                }
                setFwysZoneDisplayed(temp);
            }

            if (teesAreaPath !== undefined && showAreas.get() && teesBtn.get() && !hideAll.get() && teesZoneDisplayed.length === 0) {
                let temp = [];
                for (let i = 0; i < teesAreaPath.length; i++) {
                    teesZoneState = new mapsData.Polygon({
                        paths: teesPathCoords[i],
                        strokeColor: "#eb0c0a",
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: "#eb0c0a",
                        fillOpacity: 0.15,
                        indexID: teesAreaPath[i].Id,
                        zIndex: 2,
                    });

                    teesZoneState.setMap(map);
                    temp = [...temp, teesZoneState];

                    addListenersOnEditAreaFinalPolygon(teesZoneState);
                    polygonClick(teesZoneState);
                    polyMouseOver(teesZoneState);
                    polyMouseOut(teesZoneState);
                }
                setTeesZoneDisplayed(temp);
            }

            // ================================================ Geofence Action Zone Rendering End =============================================== //

            setNewMarker(marks);
        }
    };

    const siteAreaDrawingEventListenerAdding = () => {
        var SiteAreaDrawingManager =
            mapsData &&
            new mapsData.drawing.DrawingManager({
                drawingMode: mapsData.drawing.OverlayType.POLYGON,
                drawingControl: false,
                polygonOptions: {
                    editable: true,
                    clickable: false,
                    strokeColor: "#663a83",
                    strokeOpacity: 0.9,
                    fillOpacity: 0.2,
                    strokeWeight: 2,
                    fillColor: "#663a83",
                },
                drawingControlOptions: {
                    position: mapsData.ControlPosition.TOP_CENTER,
                    drawingModes: [mapsData.drawing.OverlayType.POLYGON],
                },
            });

        SiteAreaDrawingManager?.setMap(mapData);
        setSiteDrawAreaPolygon(SiteAreaDrawingManager);

        mapsData?.event.addListener(
            SiteAreaDrawingManager,
            "polygoncomplete",
            function (e) {
                var path = e.getPath();
                // find out the paths of this polygon

                var bounds = new mapsData.LatLngBounds();
                for (var i = 0; i < path.length; i++) {
                    bounds.extend(path.getAt(i));
                }

                let arr = [];
                // Iterate over the vertices.
                for (let i = 0; i < path.getLength(); i++) {
                    const xy = path.getAt(i);
                    arr.push({
                        lat: xy.lat(),
                        lon: xy.lng(),
                    });
                }

                setTempPolygon([...arr]);
                setAreaPolygons([e]);
                setVerticesCount(arr.length);
                setOpenAreaWindow(false);
                setOpenSiteAreaWindow(true);
                courseNameHandleChange(1);
                SiteAreaDrawingManager.setDrawingMode(
                    mapsData.drawing.OverlayType.FALSE
                );
                areaModified.set(true);
                setIsEditHole(true);
            }
        );
    };

    const holeAreaDrawingEventListenerAdding = () => {
        var AreaDrawingManager =
            mapsData &&
            new mapsData.drawing.DrawingManager({
                drawingMode: mapsData.drawing.OverlayType.POLYGON,
                cursor: "crosshair",
                drawingControl: false,
                polygonOptions: {
                    editable: true,
                    suppressUndo: true,
                    clickable: false,
                    strokeColor: "#00FF00",
                    fillOpacity: 0.2,
                    strokeWeight: 2,
                    fillColor: "red",
                    cursor: "crosshair",
                },
                drawingControlOptions: {
                    position: mapsData.ControlPosition.TOP_CENTER,
                    drawingModes: [mapsData.drawing.OverlayType.POLYGON],
                },
            });
        AreaDrawingManager?.setMap(mapData);
        setDrawAreaPolygon(AreaDrawingManager);

        mapsData?.event.addListener(
            AreaDrawingManager,
            "polygoncomplete",
            function (e, polygon) {
                var path = e.getPath();
                // find out the paths of this polygon

                var bounds = new mapsData.LatLngBounds();

                for (var i = 0; i < path.length; i++) {
                    bounds.extend(path.getAt(i));
                }

                let arr = [];
                // Iterate over the vertices.
                for (let i = 0; i < path.getLength(); i++) {
                    const xy = path.getAt(i);
                    arr.push({
                        lat: xy.lat(),
                        lon: xy.lng(),
                    });
                }
                setTempPolygon([...arr]);
                setVerticesCount(arr.length);
                setHolePolygons([e]);
                setOpenSiteAreaWindow(false);
                setOpenAreaWindow(true);
                courseNameHandleChange(1);
                AreaDrawingManager.setDrawingMode(mapsData.drawing.OverlayType.FALSE);
                areaModified.set(true);
                setIsHole(true);
                setIsEditHole(true);
            }
        );
    };

    const hideNewAreaPolygon = () => {
        drawAreaPolygon && drawAreaPolygon.setMap(null);
    };

    const showSiteAreaPolygon = () => {
        siteDrawAreaPolygon && siteDrawAreaPolygon.setMap(mapData);
    };

    const hideSiteAreaPolygon = () => {
        siteDrawAreaPolygon && siteDrawAreaPolygon.setMap(null);
    };

    const imagePreview = (childKey, childProps, mouse) => {
        var holeAreaType = {
            Tee: 0,
            Fairway: 1,
            Green: 2,
            Extents: 3,
        };

        dispatch(
            COMMON_SERVICES.getMapInformationServices(
                childProps.courseNumber,
                childProps.holeNumber,
                typeHole.get() === settingsPoITypes.hole ? settingsPoITypes.approach : settingsPoITypes.hole,
                siteId.get()
            )
        );
        imageUrl.set(mapInformationData?.Data);
        imageHoleNo.set(childProps.holeNumber);
        courseNo.set(childProps.courseNumber);
        if (typeHole.get() === undefined)
            typeHole.set(holeAreaType.green === settingsPoITypes.hole ? settingsPoITypes.approach : settingsPoITypes.hole);
        holeNum.set(childProps.holeNumber);
    };

    const checkNewMarker = () => {
        newMarker && newMarker.setMap(mapData);
    };

    const hideNewMarker = () => {
        newMarker && newMarker.setMap(null);
    };

    const actionRef = React.useRef();
    const polyRef = React.useRef();

    var polyLinesData = [];

    if (mapData && mapsData) {
        var HistoryTypeEnum = {
            History: {
                value: 0,
                name: "History",
                pathsArray: [],
                pointsArray: [],
                boundsOfAllCars: new mapsData.LatLngBounds(),
                boundsOfOneCar: new mapsData.LatLngBounds(),
            },
            GPRS: {
                value: 1,
                name: "GPRS Xmit State",
                pathsArray: [],
                pointsArray: [],
                boundsOfAllCars: new mapsData.LatLngBounds(),
                boundsOfOneCar: new mapsData.LatLngBounds(),
            },
            GPS: {
                value: 2,
                name: "GPS Quality",
                pathsArray: [],
                pointsArray: [],
                boundsOfAllCars: new mapsData.LatLngBounds(),
                boundsOfOneCar: new mapsData.LatLngBounds(),
            },
            WiFi: {
                value: 3,
                name: "Wi-Fi Signal",
                pathsArray: [],
                pointsArray: [],
                boundsOfAllCars: new mapsData.LatLngBounds(),
                boundsOfOneCar: new mapsData.LatLngBounds(),
            },
        };
    }

    const toggleShowHoleMarker = () => {
        dispatch(COMMON_SERVICES.getHoleMarkerServices(siteId.get()));
        setShowHoleMarker(!showHoleMarker);
    };

    const onCancelInteraction = () => {
        if (modalState === "tee") {
            setTeeMarkersDataState(siteSetupState[0]?.TeeMarkers);
        } else if (modalState === "poi") {
            setPointsOfInterestDataState(siteSetupState[0]?.PointsOfInterest);
        } else if (modalState === "cog") {
            setCenterGreenDataState(siteSetupState[0]?.HoleDatas);
        }
    };

    const onCircleInteraction = (childKey, childProps, mouse) => {
        if (childProps?.markerName === "tee" && teeMarkersDataState) {
            let index = teeMarkersDataState?.findIndex((it) => it.Id === childKey);
            let data = JSON.parse(JSON.stringify(teeMarkersDataState));

            if (data[index]) {
                data[index].Lat = mouse?.lat;
                data[index].Lon = mouse?.lng;
            }

            setTeeMarkersDataState(data);
            setSetting({ draggable: false });
        } else if (childProps?.markerName === "poi" && pointsOfInterestDataState) {
            let index = pointsOfInterestDataState?.findIndex((it) => it.Id === childKey);
            let data = JSON.parse(JSON.stringify(pointsOfInterestDataState));

            if (data[index]) {
                data[index].Lat = mouse?.lat;
                data[index].Lon = mouse?.lng;
            }

            setPointsOfInterestDataState(data);
            setSetting({ draggable: false });
        } else if (childProps?.markerName === "cog" && centerGreenDataState) {
            let index = centerGreenDataState?.findIndex((it) => it.Id === childKey);
            let data = JSON.parse(JSON.stringify(centerGreenDataState));

            if (data[index]) {
                data[index].Lat = mouse?.lat;
                data[index].Lon = mouse?.lng;
            }

            setCenterGreenDataState(data);
            setSetting({ draggable: false });
        }

        const Latitude = mouse?.lat;
        const Longitude = mouse?.lng;

        if (showCenterOfGreens.get()) {
            const updatedValue = JSON.parse(JSON.stringify(centerGreenDataState));
            let addValue = updatedValue.map((x) => ({ ...x, draggable: false }));
            let filterValue = addValue.filter((item) => item.Id === childKey);
            let updatedCoords = filterValue.map((x) => ({
                ...x,
                CogLat: Latitude,
                CogLon: Longitude,
            }));

            let objIndex = updatedValue?.findIndex((obj) => obj.Id === updatedCoords[0]?.Id);
            addValue[objIndex] = updatedCoords[0];
            setCenterGreenDataState(addValue);
        } else if (showTeeMarkers.get()) {
            const updatedValue = JSON.parse(JSON.stringify(teeMarkersDataState));
            let addValue = updatedValue.map((x) => ({ ...x, draggable: false }));
            let filterValue = addValue.filter((item) => item.Id === childKey);
            let updatedCoords = filterValue.map((x) => ({
                ...x,
                Lat: Latitude,
                Lon: Longitude,
            }));
            let objIndex = updatedValue?.findIndex((obj) => obj.Id === updatedCoords[0]?.Id);

            if (objIndex) {
                addValue[objIndex] = updatedCoords[0];
                setTeeMarkersDataState(addValue);
            }
        } else if (showPointsOfInterest.get()) {
            const updatedValue = JSON.parse(
                JSON.stringify(pointsOfInterestDataState)
            );
            let addValue = updatedValue.map((x) => ({ ...x, draggable: false }));
            let filterValue = addValue.filter((item) => item.Id === childKey);
            let updatedCoords = filterValue.map((x) => ({
                ...x,
                Lat: Latitude,
                Lon: Longitude,
            }));
            let objIndex = updatedValue?.findIndex((obj) => obj.Id === updatedCoords[0]?.Id);
            addValue[objIndex] = updatedCoords[0];
            setPointsOfInterestDataState(addValue);
        }
    };

    const onCircleInteraction3 = (childKey, childProps, mouse, clickEvent) => {
        setEditModel(false);
        if (clickWindowState.get()) return;
        if (clickEvent && childProps) {
            if (childProps.markerName === "cog") {
                if (mouse.y > window.innerHeight - 300) {
                    mouse.y = window.innerHeight - 300;
                }
            } else if (
                childProps.markerName !== "tee" &&
                childProps.markerName !== "poi"
            ) {
                if (mouse.y > window.innerHeight - 300) {
                    mouse.y = window.innerHeight - 300;
                }
            } else {
                if (mouse.y > window.innerHeight - 450) {
                    mouse.y = window.innerHeight - 450;
                }
            }
            if (mouse.x > window.innerWidth - 300) mouse.x = window.innerWidth - 350;
            let obj = {
                position: "fixed",
                top: 50 + mouse.y + "px",
                left: 100 + mouse.x + "px",
            };
            setSitesetupDialogBox(obj);
        }
        setSetting({ draggable: true });
        openEditModal(
            childProps?.markerName,
            editSiteSetup,
            setModalState,
            showCenterOfGreens,
            showTeeMarkers,
            showPointsOfInterest,
            setOpenModel,
            setOpenAreaWindow,
            setEditModel
        );
        let courseName = childProps?.courseNumber;
        handleEditCourseChange(courseName);
        setEditHoleNo(childProps?.holeNumber);
        setTeeEditValue(childProps?.teeMarkerSeetingId);
        setTeeEditCopy(childProps?.teeMarkerSeetingId);
        setPoiEditTypeCopy(childProps?.type);
        setPoiEditTypeValue(childProps?.type);
        typeHole.set(childProps?.type);
        setPoiEditPositionValue(childProps?.position);
        setPoiEditPositionCopy(childProps?.position);
        setEditLatLng({ lat: mouse?.lat, lng: mouse?.lng });
        setDeleteId(childKey);
        setEditId(childKey);
        imagePreview(childKey, childProps, mouse);
    };

    const _onChange = ({ center }) => {
        if (clickState?.state) {
            setDragCenter({
                center: {
                    lat: clickState?.data?.Latitude,
                    lng: clickState.data.Longitude,
                },
            });
        } else setDragCenter({ lat: center.lat, lng: center.lng });
    };

    const removeHoleMarker = () => {
        setPopupState(false);
        cancelMarkers();
    };

    const clickToDrivefeature = (event) => {
        let siteIdGet = siteId.get();

        if (showTaggedCarArrayClickToDriveInputValueSetter.get().length !== 0 && enableClickToDriveFeature.get()) {
            let carIdArray = [...showTaggedCarArrayClickToDriveInputValueSetter.get()];

            let carIds = carIdArray.toString();
            let carLat = event.latLng.lat();
            let carLng = event.latLng.lng();

            if (carIds && carLat && carLng) {
                setCarSnackbarInfo({
                    lng: carLng,
                    lat: carLat,
                });

                dispatch(COMMON_SERVICES.setClickToDriveServices(carIds, carLat, carLng, siteIdGet));

                setSnackbarState({ ...snackbarState, openSnackbar: true });
            }
        } else {
            if (enableClickToDriveFeature.get()) {
                setCTDModal(true);
            }
        }
    };

    function saveMarkers() {
        if (addSelectType.get() === siteSettingsTypes.centerOfGreen) {
            let existHole = teeHoleNumbers.includes(holeNo);
            if (existHole) {
                setPopupState(true);
                ourData.tee.pop();
            }
        } else if (addSelectType.get() === siteSettingsTypes.teeMarkers) {
            let getLatLng = ourData.tee.length - 1;
            let existHole = teeMarkersDataState.filter((t) => t.SiteId == siteId.get() && t.Hole === holeNo && t.TeeMarkerSettingId === teeValue && t.Course === courseName);
            if (existHole.length > 0) {
                setPopupState(true);
                ourData.tee.pop();
            }
            else {
                let payload = {
                    Id: 0,
                    SiteId: Number(siteId.get()),
                    TeeMarkerSettingId: teeValue,
                    Course: courseName,
                    Hole: holeNo,
                    Lat: ourData.tee[getLatLng]?.lat,
                    Lon: ourData.tee[getLatLng]?.lng,
                    SettingsTee: teeMarkeSeetingId,
                };

                dispatch(COMMON_SERVICES.postTeeMarkerServices(payload)).then(() => {
                    let item = {
                        SiteId: Number(siteId.get()),
                        TeeMarkerSettingId: teeValue,
                        Course: courseName,
                        Hole: holeNo,
                        Lat: ourData.tee[getLatLng]?.lat,
                        Lon: ourData.tee[getLatLng]?.lng,
                    }
                    const newDataTemp = [...teeMarkersDataState, item]
                    setTeeMarkersDataState(newDataTemp);
                    setHoleNo(holeNo);
                });
                teeSiteData.set(true);
            }
        } else if (addSelectType.get() === siteSettingsTypes.pointOfInterest) {
            let getLatLng = ourData.poi.length - 1;

            let payload = {
                Course: courseName,
                Hole: holeNo,
                Id: 0,
                LabelPosition: poiPositionValue,
                Lat: ourData.poi[getLatLng]?.lat,
                Lon: ourData.poi[getLatLng]?.lng,
                SiteId: Number(siteId.get()),
                Type: poiTypeValue,
            };

            dispatch(COMMON_SERVICES.postPoiMarkerServices(payload)).then(() => {
                setOurData((prev) => ({
                    ...prev,
                    poi: [],
                }));
                poiSiteData.set(true);
                setPointsOfInterestDataState((prevData) => [...prevData, payload]);
            });
        }

        setOpenModel(false);
    }

    function saveEditMarkers() {
        setEditCogTeePoiSaveActiveButton(false);
        if (modalState === "poi") {
            let newDataTemp = JSON.parse(JSON.stringify(pointsOfInterestDataState));
            let filterData =
                newDataTemp &&
                newDataTemp.lenght !== 0 &&
                newDataTemp.filter((el) => {
                    return el?.Id === Number(editId);
                });

            filterData[0].Course = courseEditName;
            filterData[0].Hole = editHoleNo;
            filterData[0].Id = Number(editId);
            filterData[0].LabelPosition = poiEditPositionValue;
            filterData[0].Lat = editLatLng?.lat;
            filterData[0].Lon = editLatLng?.lng;
            filterData[0].SiteId = Number(siteId.get());
            filterData[0].Type = poiEditTypeValue;

            let chk = newDataTemp.findIndex((e) => e?.Id === Number(editId));

            newDataTemp[chk].Course = courseEditName;
            newDataTemp[chk].Hole = editHoleNo;
            newDataTemp[chk].Id = Number(editId);
            newDataTemp[chk].LabelPosition = poiEditPositionValue;
            newDataTemp[chk].Lat = editLatLng?.lat;
            newDataTemp[chk].Lon = editLatLng?.lng;
            newDataTemp[chk].SiteId = Number(siteId.get());
            newDataTemp[chk].Type = poiEditTypeValue;

            setPointsOfInterestDataState(newDataTemp);

            let payload = {
                Course: courseEditName,
                Hole: editHoleNo,
                Id: Number(editId),
                LabelPosition: poiEditPositionValue,
                Lat: editLatLng?.lat,
                Lon: editLatLng?.lng,
                SiteId: Number(siteId.get()),
                Type: poiEditTypeValue,
            };

            let siteIdGet = siteId.get();

            dispatch(
                COMMON_SERVICES.putPoiMarkerServices(
                    payload,
                    Number(editId),
                    Number(siteId.get())
                )
            ).then(() => {
                poiSiteData.set(true);
                let imageData = {
                    courseNumber: courseEditName,
                    holeNumber: editHoleNo,
                    siteIdGet,
                };
                imagePreview({}, imageData, {});
            });
        } else if (modalState === "tee") {
            let newDataTemp = JSON.parse(JSON.stringify(teeMarkersDataState));
            let filterData =
                newDataTemp &&
                newDataTemp.lenght !== 0 &&
                newDataTemp.filter((el) => {
                    return el?.Id === Number(editId);
                });

            filterData[0].Course = courseEditName;
            filterData[0].Hole = editHoleNo;
            filterData[0].Id = Number(editId);
            filterData[0].Lat = editLatLng?.lat;
            filterData[0].Lon = editLatLng?.lng;
            filterData[0].SiteId = Number(siteId.get());
            filterData[0].TeeMarkerSettingId = teeEditValue;

            let chk = newDataTemp.findIndex((e) => e?.Id === Number(editId));

            newDataTemp[chk].Course = courseEditName;
            newDataTemp[chk].Hole = editHoleNo;
            newDataTemp[chk].Id = Number(editId);
            newDataTemp[chk].Lat = editLatLng?.lat;
            newDataTemp[chk].Lon = editLatLng?.lng;
            newDataTemp[chk].SiteId = Number(siteId.get());
            newDataTemp[chk].TeeMarkerSettingId = teeEditValue;

            setTeeMarkersDataState(newDataTemp);

            let payload = {
                Course: courseEditName,
                Hole: editHoleNo,
                Id: Number(editId),
                Lat: editLatLng?.lat,
                Lon: editLatLng?.lng,
                SiteId: Number(siteId.get()),
                TeeMarkerSettingId: teeEditValue,
            };

            let siteIdGet = siteId.get();

            dispatch(
                COMMON_SERVICES.putTeeMarkerServices(
                    payload,
                    Number(editId),
                    Number(siteId.get())
                )
            ).then(() => {
                teeSiteData.set(true);
                dispatch(COMMON_SERVICES.getAllSiteSetupServices(siteId.get()));
                let imageData = {
                    courseNumber: courseEditName,
                    holeNumber: editHoleNo,
                    siteIdGet,
                };
                imagePreview({}, imageData, {});
            });
        } else if (modalState === "cog") {
            let newDataTemp = JSON.parse(JSON.stringify(centerGreenDataState));
            let chk = newDataTemp.findIndex((e) => e?.Id === Number(editId));
            setCenterGreenDataState(newDataTemp);
            let payload = {
                Id: Number(editId),
                SiteId: Number(siteId.get()),
                Course: courseEditName,
                Hole: editHoleNo,
                Par: newDataTemp[chk].Par,
                Handicap: newDataTemp[chk].Handicap,
                CogLat: editLatLng?.lat,
                CogLon: editLatLng?.lng,
                ApproachViewYards: newDataTemp[chk].ApproachViewYards,
                StartTimeTee: newDataTemp[chk].StartTimeTee,
                StartTimeFairway: newDataTemp[chk].StartTimeFairway,
                StartAfterTee: newDataTemp[chk].StartAfterTee,
                IsStartHole: newDataTemp[chk].IsStartHole,
                IsTurnHole: newDataTemp[chk].IsTurnHole,
                ParL: newDataTemp[chk].ParL,
                HandicapL: newDataTemp[chk].HandicapL,
                HasHoleView: newDataTemp[chk].HasHoleView,
                MinHoleTimeMinutes: newDataTemp[chk].MinHoleTimeMinutes,
                BlindShotHole: newDataTemp[chk].BlindShotHole,
                BlindShotYardsFromCog: newDataTemp[chk].BlindShotYardsFromCog,
            };

            let siteIdGet = siteId.get();

            dispatch(
                COMMON_SERVICES.putCOGDataServices(
                    payload,
                    Number(editId),
                    Number(siteId.get())
                )
            ).then(() => {
                showSiteData.set(true);
                let imageData = {
                    courseNumber: courseEditName,
                    holeNumber: editHoleNo,
                    siteIdGet,
                };
                imagePreview({}, imageData, {});
            });
        }

        setEditModel(false);
    }

    function cancelMarkers() {
        if (addSelectType.get() === siteSettingsTypes.teeMarkers) {
            setOurData((prev) => ({
                ...prev,
                tee: [],
            }));
        } else if (addSelectType.get() === siteSettingsTypes.pointOfInterest) {
            setOurData((prev) => ({
                ...prev,
                poi: [],
            }));
        } else if (addSelectType.get() === siteSettingsTypes.centerOfGreen) {
            setOurData((prev) => ({
                ...prev,
                cog: [],
            }));
        }

        setOpenModel(false);
    }

    const siteAreadrawingEnentlistenerAdding = () => {
        var SiteAreaDrawingManager =
            mapsData &&
            new mapsData.drawing.DrawingManager({
                drawingMode: mapsData.drawing.OverlayType.POLYGON,
                drawingControl: false,
                polygonOptions: {
                    editable: true,
                    clickable: false,
                    strokeColor: "#663a83",
                    fillOpacity: 0.2,
                    strokeWeight: 2,
                    fillColor: "#663a83",
                },
                drawingControlOptions: {
                    position: mapsData.ControlPosition.TOP_CENTER,
                    drawingModes: [mapsData.drawing.OverlayType.POLYGON],
                },
            });

        SiteAreaDrawingManager?.setMap(mapData);
        setSiteDrawAreaPolygon(SiteAreaDrawingManager);

        mapsData?.event.addListener(
            SiteAreaDrawingManager,
            "polygoncomplete",
            function (e, polygon) {
                var path = e.getPath();
                // find out the paths of this polygon

                var bounds = new mapsData.LatLngBounds();
                for (var i = 0; i < path.length; i++) {
                    bounds.extend(path.getAt(i));
                }

                let arr = [];
                // Iterate over the vertices.
                for (let i = 0; i < path.getLength(); i++) {
                    const xy = path.getAt(i);
                    arr.push({
                        lat: xy.lat(),
                        lon: xy.lng(),
                    });
                }

                setTempPolygon([...arr]);
                setAreaPolygons([e]);
                setVerticesCount(arr.length);
                setOpenAreaWindow(false);
                setOpenSiteAreaWindow(true);
                courseNameHandleChange(1);
                SiteAreaDrawingManager.setDrawingMode(
                    mapsData.drawing.OverlayType.FALSE
                );
                areaModified.set(true);
                setIsEditHole(true);
            }
        );
    };

    const cancelSiteAreaModal = () => {
        setOpenSiteAreaWindow(false);
        if (addSiteSetup.get()) {
            siteAreadrawingEnentlistenerAdding();
            areaPolygons.forEach((it) => it.setMap(null));
            setRemoveAddPolygon(true);
        }
    };

    const discardChangesForSiteArea = () => {
        setEditCogTeePoiSaveActiveButton(false);
        setAddCogTeePoiSaveActiveButton(false);
        setSiteSetupSaveActiveButton(false);
        setSiteAreaSaveActiveButton(false);
        setOpenAreaWindow(false);
        setOpenSiteAreaWindow(false);
        dialogCancelValue === "cancelSiteAreaModal" && cancelSiteAreaModal();
        dialogCancelValue === "cancelModal" && cancelModal();
        dialogCancelValue === "cancelMarkers" && cancelMarkers();
        dialogCancelValue === "handleEditClose" && handleEditClose();

        if (areaModified.get() && editSiteSetup.get()) {
            setTempSiteEdit([]);
            areaModified.set(false);
            setIsTempPolygon(false);

            resetPrevPolygon(
                siteSetupState,
                isSiteAreaPolygon,
                isHoleAreaPolygon,
                tempSiteData,
                siteAreaClickEventData,
                siteAreaClickEvent,
                indexId,
                mapData,
                mapsData,
                teesAreaPathState,
                teesPathCoordsState,
                fwysAreaPathState,
                fwysPathCoordsState,
                gmsAreaPathState,
                gmsPathCoordsState,
                extsAreaPathState,
                extsPathCoordsState,
                stgsAreaPathState,
                stgsPathCoordsState,
                removeRequiredHoleAreaPolygon,
                removeRequiredSiteAreaPolygon,
                addListenersOnEditAreaFinalPolygon,
                addListenersOnEditSiteAreaChangesPolygon,
                addListenersOnEditSiteAreaFinalPolygon,
                updateClickedSiteAreaPolygon,
                updateClickedHoleAreaPolygon,
                teesZoneDisplayed,
                fwysZoneDisplayed,
                gmsZoneDisplayed,
                extsZoneDisplayed,
                stgsZoneDisplayed
            );
        }

        areaModified.set(false);
        setAlertModalIsOpen(false);
    };

    const handleEditClose = (event, reason) => {
        if (reason && reason === "backdropClick") return;
        setEditModel(false);
        onCancelInteraction();
    };

    const courseNameHandleChange = (e) => {
        setCourseNameModel(e?.target ? e.target.value : e);
        let data = siteSettingsData.Courses;
        let obj = data.find((o) => (o.Number === e?.target ? e.target.value : e));
        let holeNumber = obj.HoleCount;
        let firstTimeModalOpen = e?.target ? e.target.value : null;
        if (firstTimeModalOpen !== null) {
            setSiteSetupSaveActiveButton(true);
            areaModified.set(true);
        }
        setHoleCount(holeNumber);
    };

    const courseTypeHandleChange = (e) => {
        let firstTimeModalOpen = e?.target ? e.target.value : null;
        if (firstTimeModalOpen !== null) {
            setSiteSetupSaveActiveButton(true);
            areaModified.set(true);
        }
        setCourseTypeModel(e.target ? e.target.value : e);
    };

    const cancelModal = (e) => {
        if (addSiteSetup.get()) {
            holeAreaDrawingEventListenerAdding();
            setOpenAreaWindow(false);
            resetHoleAreaForm();
            if (isHole) {
                holePolygons.forEach((it) => it.setMap(null));
                setIsHole(false);
                setIsEditHole(false);
            } else {
                areaPolygons.forEach((it) => it.setMap(null));
                setIsEditHole(false);
            }
        } else {
            setOpenAreaWindow(false);
            setOpenSiteAreaWindow(false);
            editSelectedData?.setOptions({
                editable: false,
                fillOpacity: 0.2,
            });
        }
        resetHoleAreaForm();
    };

    const cancelDialogOpen = (e) => {
        if (e === "cancelModal") {
            if (isNewEditPolygon()) {
                setDiscardModalOnLeave(discardChangesForSiteArea);

                setDialogCancelValue(e);
            } else {
                if (editSiteSetup.get()) {
                    setOpenAreaWindow(false);
                    setDialogCancelValue(e);

                    cancelModal(true);
                    setIsTempPolygon(false);

                    holePolygons.forEach((it) => it.setMap(null));
                    setTempSiteEdit([]);
                    editSelectedData?.setOptions({
                        editable: false,
                        fillOpacity: 0.2,
                    });
                } else {
                    setDiscardModalOnLeave(discardChangesForSiteArea);

                    setDialogCancelValue(e);
                }
            }
        } else if (e === "handleEditClose") {
            if (modalState === "cog") {
                if (isNewEditCog()) {
                    setDiscardModalOnLeave(discardChangesForSiteArea);
                    setDialogCancelValue(e);
                } else {
                    handleEditClose();
                }
            } else if (modalState === "poi") {
                if (isNewEditPoi()) {
                    setDiscardModalOnLeave(discardChangesForSiteArea);

                    setDialogCancelValue(e);
                } else {
                    handleEditClose();
                }
            } else if (modalState === "tee") {
                if (isNewEditTee()) {
                    setDiscardModalOnLeave(discardChangesForSiteArea);

                    setDialogCancelValue(e);
                } else {
                    handleEditClose();
                }
            } else if (modalState === undefined) {
                handleEditClose();
            }
        } else if (e === "cancelMarkers") {
            setDialogCancelValue(e);
            if (
                (addSelectType.get() === siteSettingsTypes.centerOfGreen && ourData.cog.length > 0) ||
                (addSelectType.get() === siteSettingsTypes.teeMarkers && ourData.tee.length > 0) ||
                (addSelectType.get() === siteSettingsTypes.pointOfInterest && ourData.poi.length > 0)
            ) {
                setDiscardModalOnLeave(discardChangesForSiteArea);
            } else {
                cancelMarkers();
            }
        } else if (e === "cancelSiteAreaModal") {
            if (editSiteSetup.get()) {
                if (siteAreaSaveActiveButton) {
                    setDiscardModalOnLeave(discardChangesForSiteArea);

                    setDialogCancelValue(e);
                } else {
                    setOpenSiteAreaWindow(false);
                    setDialogCancelValue(e);
                    setIsTempPolygon(false);
                    editSelectedData?.setOptions({
                        editable: false,
                        fillOpacity: 0.2,
                    });
                }
            } else {
                setDiscardModalOnLeave(discardChangesForSiteArea);

                setDialogCancelValue(e);
            }
        }
    };

    const resetHoleAreaForm = () => {
        setCourseNameModel(1);
        setHoleNoModel(1);
        setCourseTypeModel(1);
    };

    const isNewEditCog = () => {
        if (editSiteSetup.get()) {
            if (modalState === "cog") {
                let newDataTemp = JSON.parse(JSON.stringify(centerGreenDataState));
                let filterData =
                    newDataTemp &&
                    newDataTemp.lenght !== 0 &&
                    newDataTemp.filter((el) => {
                        return el?.Id === Number(editId);
                    });
                if (
                    filterData[0]?.Course !== courseEditName ||
                    filterData[0]?.Hole !== editHoleNo
                ) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    };

    const isNewEditPoi = () => {
        if (editSiteSetup.get()) {
            if (modalState === "poi") {
                let newDataTemp = JSON.parse(JSON.stringify(pointsOfInterestDataState));
                let filterData =
                    newDataTemp &&
                    newDataTemp.lenght !== 0 &&
                    newDataTemp.filter((el) => {
                        return el?.Id === Number(editId);
                    });
                if (filterData[0]?.Course !== courseEditName ||
                    filterData[0]?.Type !== poiEditTypeCopy ||
                    filterData[0]?.Hole !== editHoleNo ||
                    filterData[0]?.LabelPosition !== poiEditPositionCopy
                ) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    };

    const isNewEditTee = () => {
        if (editSiteSetup.get()) {
            if (modalState === "tee") {
                let newDataTemp = JSON.parse(JSON.stringify(teeMarkersDataState));
                let filterData =
                    newDataTemp &&
                    newDataTemp.lenght !== 0 &&
                    newDataTemp.filter((el) => {
                        return el?.Id === Number(editId);
                    });
                if (filterData[0]?.Course !== courseEditName ||
                    filterData[0]?.Hole !== editHoleNo ||
                    filterData[0]?.TeeMarkerSettingId !== teeEditCopy
                ) {
                    return true;
                }
            }
        }
    };

    const isNewEditPolygon = () => {
        if (editSiteSetup.get()) {
            let filterValue = finalDataState?.length > 0 && finalDataState[0]?.HoleAreas?.filter((item) => item.Id === indexId);

            if (isEditHole) {
                setOpenAreaWindow(false);
                if (isHole) {
                    holePolygons.forEach((it) => it.setMap(null));
                    setIsHole(false);
                    setIsEditHole(false);
                } else {
                    setIsEditHole(false);
                    areaPolygons.forEach((it) => it.setMap(null));
                }
            }
            if (filterValue === undefined) return;
            if (
                (filterValue.length &&
                    (courseNameModel !== filterValue[0].Course ||
                        holeNoModel !== filterValue[0].Hole ||
                        courseTypeModel !== filterValue[0].Type)) ||
                isTempPolygon
            ) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    };

    // save and edit site area polygon
    const saveSiteArea = () => {
        editSelectedData?.setOptions({
            editable: false,
            fillOpacity: 0.2,
        });
        setSiteAreaSaveActiveButton(false);
        areaModified.set(false);

        let payload = {
            Id: addSiteSetup.get() ? 0 : tempSiteId[0].Id,
            SiteId: Number(siteId.get()),
            Polygon: addSiteSetup.get()
                ? tempPolygon
                : tempSiteEdit.length
                    ? tempSiteEdit
                    : tempSiteId[0].Polygon,
            Type: Number(siteAreaType),
        };

        if (addSiteSetup.get()) {
            dispatch(COMMON_SERVICES.postSiteAreaServices(payload)).then(() =>
                dispatch(COMMON_SERVICES.getAllSiteSetupServices(siteId.get())));
        } else if (editSiteSetup.get()) {
            dispatch(COMMON_SERVICES.putSiteAreaDataServices(payload, tempSiteId[0].Id, Number(siteId.get()))).then(() =>
                dispatch(COMMON_SERVICES.getAllSiteSetupServices(siteId.get())));
        }

        isSaveSiteArea.set(true);
    };

    // save and edit hole area polygon
    const saveHoleArea = async () => {
        let apiData =
            siteSetupState && siteSetupState !== undefined && siteSetupState;
        if (siteSetupState && siteSetupState !== undefined) {
            let existHole = apiData[0]?.HoleAreas?.Hole?.includes(holeNoModel);

            if (existHole) {
                saveErrorModal(true);
                setTempPolygon([]);
            }

            let payload = {
                SiteId: Number(siteId.get()),
                Course: courseNameModel,
                Hole: Number(holeNoModel),
                Polygon: addSiteSetup.get()
                    ? tempPolygon
                    : tempSiteEdit.length
                        ? tempSiteEdit
                        : tempSiteId[0].Polygon,
                Type: Number(courseTypeModel),
            };

            if (addSiteSetup.get()) {
                const filteredData = siteSetupData?.HoleAreas?.filter(
                    (item, index) =>
                        payload?.Course === item?.Course &&
                        payload?.Hole === item?.Hole &&
                        payload?.Type === item?.Type
                );

                if (filteredData?.length && Number(courseTypeModel) !== 0) {
                    return setOpenAlertModal(true);
                } else {
                    setSiteSetupSaveActiveButton(false);
                    areaModified.set(false);
                    editSelectedData?.setOptions({
                        editable: false,
                        fillOpacity: 0.2,
                    });
                }

                dispatch(COMMON_SERVICES.postHoleAreaServices(payload)).then(() =>
                    dispatch(COMMON_SERVICES.getAllSiteSetupServices(siteId.get())));
            } else if (editSiteSetup.get()) {
                payload["Id"] = tempSiteId[0].Id;
                setSiteSetupSaveActiveButton(false);
                dispatch(COMMON_SERVICES.putHoleAreaDataServices(payload, tempSiteId[0].Id, Number(siteId.get()))).then(() =>
                    dispatch(COMMON_SERVICES.getAllSiteSetupServices(siteId.get())));
            }

            isSaveHoleArea.set(true);
        }
    };

    function removeRequiredHoleAreaPolygon() {
        let tempSiteSetupState = JSON.parse(JSON.stringify(siteSetupState));
        let tempHoleArea = tempSiteSetupState[0].HoleAreas?.find(
            (item) => item.Id === indexId
        );
        if (tempHoleArea?.Type === 0) {
            teesZoneDisplayed.filter((item, i) => {
                if (item?.indexID === indexId) {
                    item?.setMap(null);
                    teesZoneDisplayed.splice(i, 1);
                }
            });
        } else if (tempHoleArea?.Type === 1) {
            fwysZoneDisplayed.filter((item, i) => {
                if (item.indexID === indexId) {
                    item?.setMap(null);
                    fwysZoneDisplayed.splice(i, 1);
                }
            });
        } else if (tempHoleArea?.Type === 2) {
            gmsZoneDisplayed.filter((item, i) => {
                if (item.indexID === indexId) {
                    item?.setMap(null);
                    gmsZoneDisplayed.splice(i, 1);
                }
            });
        } else if (tempHoleArea?.Type === 3) {
            extsZoneDisplayed.filter((item, i) => {
                if (item.indexID === indexId) {
                    item?.setMap(null);
                    extsZoneDisplayed.splice(i, 1);
                }
            });
        }
    }

    function removeRequiredSiteAreaPolygon() {
        let tempSiteSetupState = JSON.parse(JSON.stringify(siteSetupState));
        let tempSiteArea = tempSiteSetupState[0].SiteAreas?.find(
            (item) => item.Id === tempSiteData[0]?.Id
        );
        if (tempSiteArea?.Type === 0) {
            stgsZoneDisplayed.filter((item, i) => {
                if (item.indexID === tempSiteData[0]?.Id) {
                    item?.setMap(null);
                    stgsZoneDisplayed.splice(i, 1);
                }
            });
        }
    }

    const deleteSiteArea = () => {
        dispatch(
            COMMON_SERVICES.deleteSiteAreaServices(
                tempSiteData[0]?.Id,
                Number(siteId.get())
            )
        ).then(() => {
            setOpenSiteAreaWindow(false);
            removeRequiredSiteAreaPolygon();
        });
    };

    const deleteHoleArea = async () => {
        await dispatch(
            COMMON_SERVICES.deleteHoleAreaServices(
                tempSiteId[0].Id,
                Number(siteId.get())
            )
        ).then(() => {
            setOpenAreaWindow(false);
            removeRequiredHoleAreaPolygon();
        });
    };

    const createDeleteVertexElement = () => {
        let deleteVertexButton = null;

        if (mapsData) {
            deleteVertexButton = class DeleteMenu extends mapsData.OverlayView {
                div_;
                divListener_;
                constructor() {
                    super();
                    this.div_ = document.createElement("button");
                    this.div_.style.cssText = `
              background-color: #fff; 
              width:30px; height:25px; 
              border-radius:4px; 
              position: fixed; 
              border:none; 
              font-size:14px; `;
                    this.div_.innerHTML = "x";
                    this.div_.className = "map-cross-icon";
                    this.div_.title = "Delete";
                    const menu = this;

                    mapsData.event.addDomListener(this.div_, "click", () => {
                        menu.removeVertex();
                    });
                }
                onAdd() {
                    const deleteVertexButton = this;
                    const map = this.getMap();

                    this.getPanes().floatPane.appendChild(this.div_);
                    // mousedown anywhere on the map except on the menu div will close the menu.
                    this.divListener_ = mapsData.event.addDomListener(
                        map.getDiv(),
                        "mousedown",
                        (e) => {
                            if (e.target !== deleteVertexButton.div_) {
                                deleteVertexButton.close();
                            }
                        },
                        true
                    );
                }
                onRemove() {
                    if (this.divListener_) {
                        mapsData.event.removeListener(this.divListener_);
                    }

                    this.div_.parentNode.removeChild(this.div_);
                    // clean up
                    this.set("position", null);
                    this.set("path", null);
                    this.set("vertex", null);
                }
                close() {
                    this.setMap(null);
                }
                draw() {
                    const position = this.get("position");
                    const projection = this.getProjection();

                    if (!position || !projection) {
                        return;
                    }

                    const point = projection.fromLatLngToDivPixel(position);
                    this.div_.style.top = point.y + "px";
                    this.div_.style.left = point.x + "px";
                }
                /**
                 * Opens the menu at a vertex of a given path.
                 */
                open(map, path, vertex, polygon) {
                    this.set("position", path.getAt(vertex));
                    this.set("path", path);
                    this.set("vertex", vertex);
                    this.set("polygon", polygon);
                    this.setMap(map);
                    this.draw();
                }
                /**
                 * Deletes the vertex from the path.
                 */
                removeVertex() {
                    const path = this.get("path");
                    const vertex = this.get("vertex");
                    const polygon = this.get("polygon");

                    let foundPoly = actionZonesPolygons.find((item) => item.actionZoneInfo.Id === polygon.actionZoneInfo.Id);

                    if (!path || vertex === undefined) {
                        this.close();
                        return;
                    }

                    let arr1 = [];
                    const vertices1 = polygon.getPaths().getArray()[0];

                    vertices1.forEach((vertex) => {
                        const lat = vertex.lat();
                        const lng = vertex.lng();

                        arr1.push({
                            Id: 0,
                            Longitude: lng,
                            Latitude: lat,
                        });
                    });

                    let duplicateIndex = [];

                    for (let i = 0; i < arr1.length; i++) {
                        if (arr1[vertex].Latitude === arr1[i].Latitude && arr1[vertex].Longitude === arr1[i].Longitude) {
                            duplicateIndex.push(i);
                        }
                    }
                    duplicateIndex.sort((a, b) => b - a);

                    duplicateIndex.map((item) => path.removeAt(item));

                    let foundFromAPI = getCarPathActionZone.find((item) => item.Id === polygon.actionZoneInfo.Id);

                    let arr = [];
                    const vertices = polygon.getPaths().getArray()[foundFromAPI?.IsGeofence ? 1 : 0];

                    vertices.forEach((vertex) => {
                        const lat = vertex.lat();
                        const lng = vertex.lng();

                        arr.push({
                            Id: 0,
                            Longitude: lng,
                            Latitude: lat,
                        });
                    });

                    let setOptionsPath = [];
                    createBufGeofenceVertices(arr).map((point) => {
                        setOptionsPath.push({
                            checkId: foundPoly?.Id,
                            lat: point.Latitude,
                            lng: point.Longitude,
                        });
                    });

                    foundPoly?.setOptions({
                        path: setOptionsPath,
                    });

                    const uniqueSet = new Set();
                    arr.map((obj) => uniqueSet.add(JSON.stringify(obj)));

                    this.close();
                }
            }
        }

        return deleteVertexButton ? new deleteVertexButton() : null;
    }

    const handleCloseHeightMapModal = () => {
        setOpenHeightMapModal(false);
    }

    return (
        <MapContainer>
            <AlertModal
                handleOnSubmit={alertModalHandleOnSubmit}
                handleOnClose={alertModalHandleOnClose}
                title={alertModalTitle}
                content={alertModalContent}
                isOpen={alertModalIsOpen}
                setOpenAlert={setAlertModalIsOpen}
                validation={alertModalValidation}
            />

            {openSiteAreaWindow && verticesCount > 1 && (
                <SiteAreaPopup
                    sitesetupDialogBox={sitesetupDialogBox}
                    siteAreaType={siteAreaType}
                    verticesCount={verticesCount}
                    TempPolygon={tempPolygon}
                    siteAreaSaveActiveButton={siteAreaSaveActiveButton}
                    cancelDialogOpen={cancelDialogOpen}
                    deleteSiteArea={deleteSiteArea}
                    saveSiteArea={saveSiteArea}
                    setSiteAreaSaveActiveButton={setSiteAreaSaveActiveButton}
                    setSiteAreaType={setSiteAreaType}
                />
            )}

            {openAreaWindow && tempPolygon.length > 1 && (
                <SiteSetupAreasPopups
                    sitesetupDialogBox={sitesetupDialogBox}
                    courseNameModel={courseNameModel}
                    courseNameHandleChange={courseNameHandleChange}
                    holeNoModel={holeNoModel}
                    holeCount={holeCount}
                    verticesCount={verticesCount}
                    courseTypeModel={courseTypeModel}
                    courseTypeHandleChange={courseTypeHandleChange}
                    TempPolygon={tempPolygon}
                    siteSetupSaveActiveButton={siteSetupSaveActiveButton}
                    cancelDialogOpen={cancelDialogOpen}
                    deleteHoleArea={deleteHoleArea}
                    saveHoleArea={saveHoleArea}
                    setSiteSetupSaveActiveButton={setSiteSetupSaveActiveButton}
                    setHoleNoModel={setHoleNoModel}
                    areaModified={areaModified}
                />
            )}

            {openModel && (
                <COGAndTeeAndPOIAddPopup
                    sitesetupDialogBox={sitesetupDialogBox}
                    courseName={courseName}
                    holeNo={holeNo}
                    holeCount={holeCount}
                    teeValue={teeValue}
                    addCogDistan={addCogDistan}
                    poiTypeValue={poiTypeValue}
                    poiPositionValue={poiPositionValue}
                    addCogTeePoiSaveActiveButton={addCogTeePoiSaveActiveButton}
                    cancelDialogOpen={cancelDialogOpen}
                    saveMarkers={saveMarkers}
                    setCourseName={setCourseName}
                    setHoleCount={setHoleCount}
                    setHoleNo={setHoleNo}
                    setAddCogTeePoiSaveActiveButton={setAddCogTeePoiSaveActiveButton}
                    setTeeValue={setTeeValue}
                    setPoiTypeValue={setPoiTypeValue}
                    setPoiPositionValue={setPoiPositionValue}
                />
            )}

            {editModel && carPopupClickEvent.get() === null && (
                <COGAndTeeAndPOIEditPopup
                    sitesetupDialogBox={sitesetupDialogBox}
                    courseEditName={courseEditName}
                    handleEditCourseChange={handleEditCourseChange}
                    editHoleNo={editHoleNo}
                    setEditHoleNo={setEditHoleNo}
                    handleEditChange={handleEditChange}
                    holeCount={holeCount}
                    teeEditValue={teeEditValue}
                    teeEditHandleChange={teeEditHandleChange}
                    cogDistan={cogDistan}
                    modalState={modalState}
                    poiEditTypeValue={poiEditTypeValue}
                    poiEditHandleChange={poiEditHandleChange}
                    poiEditPositionValue={poiEditPositionValue}
                    poiEditPositionHandleChange={poiEditPositionHandleChange}
                    saveEditMarkers={saveEditMarkers}
                    editCogTeePoiSaveActiveButton={editCogTeePoiSaveActiveButton}
                    cancelDialogOpen={cancelDialogOpen}
                    teeMarkersDataState={teeMarkersDataState}
                    setTeeMarkersDataState={setTeeMarkersDataState}
                    editId={editId}
                    deleteId={deleteId}
                    siteId={siteId.get()}
                    setEditModel={setEditModel}
                    pointsOfInterestDataState={pointsOfInterestDataState}
                    setPointsOfInterestDataState={setPointsOfInterestDataState}
                />
            )}

            <Dialog
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                open={saveErrorModal}
                onClose={() => setSaveErrorModal(false)}
            >
                <SiteSettingModalContainer>
                    <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
                        Save Error
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            This type of hole area already exists for this hole. Please select
                            a different area type to save.
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <CircleBtn onClick={() => setSaveErrorModal(false)}>
                            {t("Ok")}
                        </CircleBtn>
                    </DialogActions>
                </SiteSettingModalContainer>
            </Dialog>

            <Dialog
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                open={popupState}
                onClose={() => setPopupState(false)}
            >
                <SiteSettingModalContainer>
                    <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
                        {addSelectType.get() === siteSettingsTypes.centerOfGreen && "Center of Green Error"}
                        {addSelectType.get() === siteSettingsTypes.teeMarkers && "Tee Marker Error"}
                        {addSelectType.get() === siteSettingsTypes.pointOfInterest && "Point of Interest Error"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {addSelectType.get() === siteSettingsTypes.centerOfGreen &&
                                "This Center of Green can not be added because it already exists. Please edit the existing Center of Green."}
                            {addSelectType.get() === siteSettingsTypes.teeMarkers &&
                                "This Tee Marker can not be added because it already exists. Please edit the existing Tee Marker."}
                            {addSelectType.get() === siteSettingsTypes.pointOfInterest &&
                                "This Point of Interest can not be added because it already exists. Please edit the existing Point of Interest."}
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <CircleBtn onClick={removeHoleMarker}>{t("Ok")}</CircleBtn>
                    </DialogActions>
                </SiteSettingModalContainer>
            </Dialog>

            <FilterHeader className="for-map-filter-header">
                <div className="heightMapOpacityContainer" ref={opacityContainerRef} style={{ visibility: 'hidden' }}>
                    <input type="range" id="heightMapOpacitySlider" width={'30%'} ref={opacitySliderRef} />
                </div>

                <MapMobileMenu
                    site={site}
                    all={all}
                    setAll={setAll}
                    setSite={setSite}
                    showHoleMarker={showHoleMarker}
                    toggleShowHoleMarker={toggleShowHoleMarker}
                    handleOpen2={(e) => handleOpen2(e, setOpen2)}
                    handleToggle={() => setActiveCarList(!isActiveCarList)}
                    kmlLayerData={kmlLayerData}
                />
                <MapTopMenu
                    all={all}
                    setAll={setAll}
                    site={site}
                    setSite={setSite}
                    kmlLayerData={kmlLayerData}
                    showHoleMarker={showHoleMarker}
                    toggleShowHoleMarker={toggleShowHoleMarker}
                />
                {canAccessSiteSetup && (Math.round(siteSettingsData?.CenterPointLatitude) + Math.round(siteSettingsData?.CenterPointLongitude))
                    * (Math.round(siteSettingsData.UpperLeftLatitude) + Math.round(siteSettingsData.UpperLeftLongitude)) === 0
                    && <MapBottom
                        lat={lat}
                        lng={lng}
                        setLat={setLat}
                        setLng={setLng}
                        isValidLat={isValidLat}
                        isValidLng={isValidLng}
                        handleGoButtonClick={handleGoButtonClick}
                        handleSetSiteExtentOpen={handleSetSiteExtentOpen}
                    />}
                <MapSideMenu
                    handleOpen2={(e) => handleOpen2(e, setOpen2)}
                    handleToggle={() => setActiveCarList(!isActiveCarList)}
                />

                <MapLegend handleClose2={handleClose2} open2={open2} />
            </FilterHeader>

            <HoleAreaAlreadyExistsPopup
                openAlertModal={openAlertModal}
                setOpenAlertModal={setOpenAlertModal}
            />

            {isActiveCarList ? (
                <></>
            ) : (
                <CarList
                    setActiveCarList={setActiveCarList}
                    isActiveCarList={isActiveCarList}
                    displayCars={() => displayCars(carData, getCheckedCars.get())}
                />
            )}
            <GoogleMapReact
                onClick={(e) => {
                    drawMarker(
                        e,
                        addSiteSetup.get(),
                        addSelectType.get(),
                        setSitesetupDialogBox,
                        setOurData,
                        showTeeMarkers,
                        setOpenModel,
                        showPointsOfInterest
                    );
                }}
                bootstrapURLKeys={{
                    key: "AIzaSyBS7xNXe1Je5JAU3OToU_bxNuxDB0xGrtA",
                    language: "en",
                    libraries: ["drawing"].join(","),
                }}
                draggable={setting.draggable}
                id="map-area"
                onChange={_onChange}
                defaultCenter={editSiteSetup.get() || clickState?.state ? dragCenter.center : defaultProps.center}
                onMapTypeIdChange={(type) => {
                    mapTypeHandler.set(type);
                }}
                center={
                    editSiteSetup.get() || clickState?.state
                        ? dragCenter.center
                        : goClick ? center : defaultProps.center
                }
                defaultZoom={defaultProps.zoom}
                zoom={defaultProps.zoom}
                options={getMapOptions}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={({ map, maps }) => handleGoogleMapApis(map, maps)}
                onChildMouseDown={(childKey, childProps, mouse) => {
                    if (editSiteSetup.get()) onCircleInteraction(childKey, childProps, mouse);
                    if (!clickWindowState.get())
                        imagePreview(childKey, childProps, mouse);
                }}
                onChildMouseUp={(childKey, childProps, mouse) => {
                    carPopupClickEvent.set(null);
                    return editSiteSetup.get()
                        ? onCircleInteraction3(childKey, childProps, mouse, "clickEvent")
                        : null;
                }}
                onChildMouseMove={(childKey, childProps, mouse) => {
                    if (editSiteSetup.get()) onCircleInteraction(childKey, childProps, mouse);
                }}
            >
                {addSiteSetup.get() && addSelectType.get() === siteSettingsTypes.holeArea
                    ? showNewAreaPolygon()
                    : hideNewAreaPolygon()}

                {addSiteSetup.get() && addSelectType.get() === siteSettingsTypes.siteAreaType
                    ? showSiteAreaPolygon()
                    : hideSiteAreaPolygon()}
                {addSiteSetup.get() ? checkNewMarker() : hideNewMarker()}

                {!siteLocationGlobalData.get() &&
                    showCenterOfGreens.get() &&
                    (!hideAll.get() || holeView.get()) &&
                    centerGreenDataState &&
                    centerGreenDataState.length !== 0 ? (
                    centerGreenDataState.map((item) => (
                        <MapCenterMarker
                            key={item.Id}
                            markerName="cog"
                            lat={item?.CogLat}
                            lng={item?.CogLon}
                            uniqueId={uuid()}
                            courseNumber={item?.Course}
                            holeNumber={item?.Hole}
                        />
                    ))
                ) : (
                    <></>
                )}

                {!siteLocationGlobalData.get() &&
                    showTeeMarkers.get() &&
                    (!hideAll.get() || holeView.get()) &&
                    teeMarkersDataState &&
                    teeMarkersDataState.length !== 0 ? (
                    teeMarkersDataState.map((item) => (
                        <MapTeesMarker
                            key={item.Id}
                            markerName="tee"
                            teeMarkColorId={teeMarkeSeetingId}
                            lat={item?.Lat}
                            lng={item?.Lon}
                            uniqueId={uuid()}
                            teeMarkerSeetingId={item?.TeeMarkerSettingId}
                            courseNumber={item?.Course}
                            holeNumber={item?.Hole}
                        />
                    ))
                ) : (
                    <></>
                )}

                {!siteLocationGlobalData.get() &&
                    showPointsOfInterest.get() &&
                    (!hideAll.get() || holeView.get()) &&
                    pointsOfInterestDataState &&
                    pointsOfInterestDataState.length !== 0 ? (
                    pointsOfInterestDataState.map((item) => (
                        <MapPointMarker
                            key={item.Id}
                            markerName="poi"
                            lat={item?.Lat}
                            lng={item?.Lon}
                            uniqueId={uuid()}
                            type={item?.Type}
                            position={item?.LabelPosition}
                            courseNumber={item?.Course}
                            holeNumber={item?.Hole}
                        />
                    ))
                ) : (
                    <></>
                )}

                {siteLocationGlobalData.get() && mapData && mapsData
                    ? siteLocationsData.map((locations, index) => (
                        <LocationIcon
                            style={{ position: "relative", zIndex: 9 }}
                            tracksViewChanges={false}
                            key={"mapSiteId" + index}
                            uniqueId={"mapSiteIdUni" + index}
                            Id={locations?.Id}
                            lat={locations?.CenterPointLatitude}
                            lng={locations?.CenterPointLongitude}
                            locationName={locations?.Name}
                            IsEUSite={locations?.IsEUSite}
                        />
                    ))
                    : null}

                {((!siteLocationGlobalData.get() && carData?.length !== 0) || (tagCarFromFleet.get() && !siteLocationGlobalData.get() && tagCarFromFleet.get().length === 0)) &&
                    localStorage.getItem("mapCarsSelectAll") === "true" && !(getFeatureSetOption(
                        siteSettingsData && siteSettingsData?.Features,
                        getFeaturesList().real_time_tracking
                    ) && !(isUserAdmin(getUserRole && getUserRole.Role) || isUserSupport(getUserRole && getUserRole.Role))) ? (
                    carData.map((cars, i) => {
                        if (cars?.Car?.Latitude !== 0 && cars?.Car?.Longitude !== 0) {
                            return (
                                <MapCarIcon
                                    car={cars}
                                    tracksViewChanges={false}
                                    key={"carIconid" + i}
                                    uniqueId={"carIconidUni" + i}
                                    lat={cars?.Car?.Latitude}
                                    lng={cars?.Car?.Longitude}
                                    carNumber={cars?.Car?.CarNumber}
                                    carType={cars?.Car?.CarType}
                                    holeNumber={cars?.Car?.Hole}
                                    dateData={cars?.Car?.LastLocationUpdateInUtc}
                                    holeLocation={cars?.Car?.HoleLocation}
                                    paceStatus={cars?.Car?.Pace}
                                    batteryLevel={cars?.Car?.BatteryLevel}
                                    GpsiCarId={cars?.Car?.GpsiCarId}
                                    playername1={cars?.Car?.PlayerName1}
                                    playername2={cars?.Car?.PlayerName2}
                                    carnumber={cars?.Car?.CarNumber}
                                    wifi={cars?.Car?.LastWiFiInUtc}
                                    Course={cars?.Car?.Course}
                                    Distance={cars?.Car?.DistanceUnits}
                                    MaxSpeed={cars?.Car?.MaxSpeed}
                                    HolesPlayed={cars?.Car?.HolesPlayed}
                                    actionZoneDetector={cars?.Car?.ActionZoneId}
                                    carsPosition={carsPosition}
                                    setCarsPosition={setCarsPosition}
                                    setEditModel={setEditModel}
                                    zoomPosition={zoomPosition}
                                    secondaryCarType={cars?.Car?.SecondaryCarType}
                                    memberName={cars?.Car?.CarType === carType.member && cars?.Members && cars?.Members.length > 0 ? cars?.Members[0]?.MemberName : ""}
                                />
                            );
                        }
                    })
                ) : tagCarFromFleet.get() &&
                    !siteLocationGlobalData.get() &&
                    tagCarFromFleet.get().length !== 0 ? (
                    <TaggedCarIconComponent
                        key={uuid()}
                        uniqueId={uuid()}
                        lat={tagCarFromFleet.get() && tagCarFromFleet.get()[0]?.lat}
                        lng={tagCarFromFleet.get() && tagCarFromFleet.get()[0]?.lag}
                    />
                ) : (
                    <></>
                )}

                {!siteLocationGlobalData.get() &&
                    holeMarkerData &&
                    showHoleMarker &&
                    holeMarkerData.length !== 0 ? (
                    holeMarkerData.map((item) => (
                        <MapHoleMarker
                            key={item.Id}
                            lat={item?.Latitude}
                            lng={item?.Longitude}
                            uniqueId={uuid()}
                            courseNumber={item?.Course}
                            holeNumber={item?.Hole}
                        />
                    ))
                ) : (
                    <></>
                )}

                {!siteLocationGlobalData.get() &&
                    ourData?.poi &&
                    ourData?.poi.length !== 0 &&
                    ourData?.poi?.map((el) => {
                        return (
                            <NewMapPointMarker
                                lat={el?.lat}
                                lng={el?.lng}
                                uniqueId={uuid()}
                                type={poiTypeValue}
                                position={poiPositionValue}
                            />
                        );
                    })}

                {clickState.data && (
                    <HistoryIconPopup
                        key={uuid()}
                        lat={clickState.data.Latitude}
                        lng={clickState.data.Longitude}
                        clickState={clickState}
                        getPaceString={getPaceString}
                        setClickState={setClickState}
                    />
                )}

                {!siteLocationGlobalData.get() &&
                    ourData?.tee &&
                    ourData?.tee.length !== 0 &&
                    ourData?.tee?.map((el) => {
                        return (
                            <NewMapTeesMarker
                                lat={el?.lat}
                                lng={el?.lng}
                                uniqueId={uuid()}
                                teeMarkerSeetingId={teeValue}
                                holeNumber={holeNo}
                            />
                        );
                    })}

                {!siteLocationGlobalData.get() &&
                    ourData?.cog &&
                    ourData?.cog.length !== 0 &&
                    ourData?.cog?.map((el) => {
                        return (
                            <MapCenterMarker lat={el?.lat} lng={el?.lng} uniqueId={uuid()} />
                        );
                    })}

                {!siteLocationGlobalData.get() && markers && markers.length !== 0 ? (
                    markers.map((item) => {
                        return (
                            <div
                                draggable
                                key={uuid()}
                                lat={item?.lat}
                                lng={item?.lng}
                                style={{ color: "white" }}
                            >
                                Hello
                            </div>
                        );
                    })
                ) : (
                    <></>
                )}

                <div
                    id="history-info"
                    style={{ position: "absolute", visibility: "hidden" }}
                    className="xl"
                >
                    History
                </div>
            </GoogleMapReact>

            {hoverStateHistory?.state ? (
                <HoverWindow
                    style={{
                        position: "fixed",
                        top: `${hoverStateHistory.top}`,
                        left: `${hoverStateHistory.left}`,
                    }}
                >
                    <div className="wrapper">
                        <h3>Car: {hoverStateHistory.car}</h3>
                        <p>{hoverStateHistory.TimeStamp}</p>
                    </div>
                </HoverWindow>
            ) : (
                <></>
            )}

            {/* ================================================== TOOLTIP FOR CAR LOCATIONS =========================================== */}
            {hoverState?.state && !clickState.state ? (
                <HoverWindow
                    style={{
                        position: "fixed",
                        top: `${hoverState.top}`,
                        left: `${hoverState.left}`,
                    }}
                >
                    <div className="wrapper">
                        <div className="carSignalIcon">
                            <h3>Car: {hoverState.data.CarNumber}</h3>
                            <SignalIcon width="16px" height="12.5px" color="gray" />
                        </div>
                        <p>
                            {moment
                                .utc(hoverState.data.LastLocationUpdateInUtc)
                                .utcOffset(
                                    siteSettingsData && -siteSettingsData?.TimeZoneOffset
                                )
                                .format("DD-MMM-YYYY, h:mm a")}
                        </p>

                        {hoverState.data.PlayerName1 !== null ? (
                            <p>{hoverState.data.PlayerName1}</p>
                        ) : (
                            <></>
                        )}
                        {hoverState.data.PlayerName2 !== null ? (
                            <p>{hoverState.data.PlayerName2}</p>
                        ) : (
                            <></>
                        )}

                        <p>
                            <span style={{ fontSize: 16 }}>
                                {hoverState.data.HoleLocation === 0
                                    ? "Not playing"
                                    : hoverState.data.HoleLocation === 1
                                        ? `Hole ${hoverState.data.Hole} Between Holes `
                                        : hoverState.data.HoleLocation === 2
                                            ? `Hole ${hoverState.data.Hole} Tee`
                                            : hoverState.data.HoleLocation === 3
                                                ? `Hole ${hoverState.data.Hole} Fairway`
                                                : hoverState.data.HoleLocation === 4
                                                    ? `Hole ${hoverState.data.Hole} Green`
                                                    : ""}
                            </span>
                            <br />
                        </p>
                        <p style={{ fontSize: 16 }}>
                            {getPaceString(
                                hoverState.data.Pace,
                                hoverState.data.HolesPlayed,
                                hoverState.data.CarType
                            )}
                        </p>
                        <p>
                            {t("Report_Reason")}:
                            {reasonForReportString(hoverState.data.LocationReasonForReport)}
                        </p>
                        <p>
                            {t("GPRS_Signal")}:{hoverState.data.LocationGprsSignalStrength}{" "}
                        </p>
                        <p>
                            {t("Sequence")} #:{hoverState.data.LocationSequenceNumber}{" "}
                        </p>
                    </div>
                </HoverWindow>
            ) : (
                <></>
            )}
            {clickState?.state && <></>}
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={openSnackbar}
                message={
                    <span>
                        {`Position sent for ${showTaggedCarArrayClickToDrive.get().length
                            } car(s)`}
                        <br />
                        {carSnackbarInfo.lat}
                        <br />
                        {carSnackbarInfo.lng}
                    </span>
                }
                key={vertical + horizontal}
            />
            <CarNotAvailableModal
                notAvailableCars={notAvailableCars}
                openPopupNotAvailableCars={openPopupNotAvailableCars}
                setOpenPopupNotAvailableCars={setOpenPopupNotAvailableCars}
            />
            <SendMsgToCars />

            <CarDetailsOnCarIcon />
            <LoadingBackdrop />
            <ErrorPopup
                openErrorModal={openErrorModal}
                setOpenErrorModal={setOpenErrorModal}
            />
            <Modal
                open={CTDModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={CTDStyle}>
                    <PopUpContainer>
                        <h2>{t("No_target_car(s)")}</h2>
                        <p>{t("Target_car_number(s)_must_be_specified")}</p>
                        <div className="action-btn">
                            <button className="primary" onClick={() => setCTDModal(false)}>
                                {t("Ok")}
                            </button>
                        </div>
                    </PopUpContainer>
                </Box>
            </Modal>

            <Modal
                open={historyNoDataPopup.get()}
                onClose={() => historyNoDataPopup.set(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={historyModalStyle}>
                    <PopUpContainer>
                        <h2>Visage</h2>
                        <p> {t("No_data_was_available_to_display_on_the_map")}</p>
                        <div className="action-btn">
                            <button
                                onClick={() => {
                                    historyNoDataPopup.set(false);
                                }}
                            >
                                {t("Ok")}
                            </button>
                        </div>
                    </PopUpContainer>
                </Box>
            </Modal>

            <Modal
                open={openHeightMapModal && isHeightMapShowing}
                onClose={handleCloseHeightMapModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={historyModalStyle}>
                    <PopUpContainer>
                        <h2>Height Map Info</h2>
                        <p> {heightMapInfo && heightMapInfo?.map((line, index) => (
                            <div key={index}>{line}</div>
                        ))}
                        </p>
                        <div className="action-btn">
                            <button
                                onClick={handleCloseHeightMapModal}
                            >
                                {t("Ok")}
                            </button>
                        </div>
                    </PopUpContainer>
                </Box>
            </Modal>
            <Modal
                open={openSiteExtent}
                onClose={handleSaveExtentClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={popUpStyle}>
                    <PopUpContainer>
                        <h2>{t("Confirm")}</h2>
                        <p>{t("SiteExtent_Confirm")}</p>
                        <div className="action-btn">
                            <button
                                className="primary"
                                onClick={handleSetSiteExtentClick}
                                variant="contained"
                            >
                                {t("Yes")}
                            </button>
                            <button onClick={() => handleSaveExtentClose()}>
                                {t("No")}
                            </button>
                        </div>
                    </PopUpContainer>
                </Box>
            </Modal>
        </MapContainer>
    );
};
